<template>
  <div class="pa-4" v-allowed="'view_members_data'">
    <div v-if="!loading && !isMember">
      <div class="text-center">
        <h1 v-if="nonMember">{{ nonMember.displayName }}</h1>
        <h3 v-if="rejectedData">({{ $t("message.rejected") }})</h3>
        <div v-if="memberError" class="mb-2">
          <div class="text-h3 error--text">{{ $t("message.internal_error") }}</div>
          <div class="text-h6">{{ $t("message.contact_support") }}</div>
        </div>
        <div v-else class="text-h3">{{ $t("message.not_a_member") }}</div>
      </div>
      <member-comments v-if="rejectedData" :hide-buttons="true" :data="rejectedData" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined v-if="visitorData" elevation="0" color="primary" small @click="goToVisitor(visitorData._id)">
          {{ $t('message.visitor') }}
        </v-btn>
        <v-btn elevation="0" color="secondary" small @click="goBack()">
          {{ $t('message.back') }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </div>
    <v-skeleton-loader v-if="loading" class="mx-auto" type="card"></v-skeleton-loader>
    <div v-if="!loading && member">
      <v-card class="text-center" elevation="0" outlined>
        <v-card-text class="pa-0">
          <UserDisplay :user="member" :is-birthday="isBirthday"></UserDisplay>
        </v-card-text>
        <v-card-actions v-if="!isSmallerDisplay()" class="mt-2">
          <div class="text-left">
            <div v-if="member.referredBy">
              <span class="text-caption" @click="goToMember(member.referredBy.id)">
                {{ $t("message.referred_by") }} <b>{{ member.referredBy.name }}</b>
              </span>
            </div>
            <div>
              <span v-if="member.memberData && member.memberData.joinedDate" class="text-caption clickable">
                {{ $t("message.member_since") }} <b>{{ $d(new Date(member.memberData.joinedDate), "month_day_year",
                  $i18n.locale) }}</b>
              </span>
            </div>
            <div>
              <span v-if="member.createdOn" class="text-caption">
                {{ $t("message.bjjlink_user_since") }} <b>{{ $d(new Date(member.createdOn), "month_day_year",
                  $i18n.locale) }}</b>
                <span v-if="member.source" class="ml-1">({{ $t("message." + member.source) }})</span>
              </span>
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-btn :loading="loadingTimeline" color="primary" outlined small elevation="0" @click="getActivityTimeline()">
            <v-icon size="20" class="mr-1">mdi-timeline-clock-outline</v-icon>
            {{ $t("message.timeline") }}
          </v-btn>
          <ImageUpload color="primary" :label="$t('message.update_profile_image')"
            style="margin-right:5px;margin-left:5px" :fab="false" :vm="this" :add-small="true"
            :success-function="successUploadImage">
          </ImageUpload>
          <v-menu offset-y small>
            <template v-slot:activator="{ on }">
              <v-btn elevation="0" class="mr-1" v-on="on" small slot="activator" color="primary" outlined>
                <v-icon size="20">mdi-dots-vertical</v-icon>
                {{ $t("message.actions") }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click.stop="goToSellProduct()">
                <v-list-item-title>
                  {{ $t("message.sell_item") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop="goToSellMembership()">
                <v-list-item-title>
                  {{ $t("message.sell_membership") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop="sendNotiDialog = true">
                <v-list-item-title>
                  {{ $t("message.send_notification") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-show="false" @click.stop="sendEmailDialog = true">
                <v-list-item-title>
                  {{ $t("message.send_email") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="member.allowProfileEdit" @click.stop="showUpdateSocialProfileDialog('fName')">
                <v-list-item-title>
                  {{ $t("message.update_first_name") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="member.allowProfileEdit" @click.stop="showUpdateSocialProfileDialog('lName')">
                <v-list-item-title>
                  {{ $t("message.update_last_name") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="member.allowProfileEdit" @click.stop="showUpdateSocialProfileDialog('email')">
                <v-list-item-title>
                  {{ $t("message.update_email") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop="showUpdateSocialProfileDialog('nationality')">
                <v-list-item-title>
                  {{ $t("message.update_nationality") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop="showUpdateSocialProfileDialog('gender')">
                <v-list-item-title>
                  {{ $t("message.update_gender") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop="showUpdateSocialProfileDialog('dob')">
                <v-list-item-title>
                  {{ $t("message.update_dob") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="member.allowProfileEdit" @click.stop="showUpdateSocialProfileDialog('password')">
                <v-list-item-title>
                  {{ $t("message.reset_password") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop="showUpdateSocialProfileDialog('belt')">
                <v-list-item-title>
                  {{ $t("message.update_belt") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop="showUpdateSocialProfileDialog('isMinor')">
                <v-list-item-title v-if="member && member.isMinor">
                  {{ $t("message.update_to_adult") }}
                </v-list-item-title>
                <v-list-item-title v-else>
                  {{ $t("message.is_minor") }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-actions>
        <div v-else class="pa-2">
          <div v-if="member.referredBy">
            <span class="text-caption" @click="goToMember(member.referredBy.id)">
              {{ $t("message.referred_by") }} <b>{{ member.referredBy.name }}</b>
            </span>
          </div>
          <div v-if="member.memberData && member.memberData.joinedDate" class="text-caption">
            {{ $t("message.member_since") }} <b>{{ $d(new Date(member.memberData.joinedDate), "month_day_year",
              $i18n.locale) }}</b>
          </div>
          <div>
            <span v-if="member.createdOn" class="text-caption">
              {{ $t("message.bjjlink_user_since") }} <b>{{ $d(new Date(member.createdOn), "month_day_year",
                $i18n.locale) }}</b>
              <span v-if="member.source" class="ml-1">({{ $t("message." + member.source) }})</span>
            </span>
          </div>
          <v-menu offset-y small class="mt-1">
            <template v-slot:activator="{ on }">
              <v-btn class="mt-1" elevation="0" block v-on="on" small slot="activator" color="primary" outlined>
                <v-icon size="20">mdi-dots-vertical</v-icon>
                {{ $t("message.actions") }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click.stop="getActivityTimeline()">
                <v-list-item-title>
                  {{ $t("message.timeline") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop="goToSellProduct()">
                <v-list-item-title>
                  {{ $t("message.sell_item") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop="goToSellMembership()">
                <v-list-item-title>
                  {{ $t("message.sell_membership") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop="sendNotiDialog = true">
                <v-list-item-title>
                  {{ $t("message.send_notification") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-show="false" @click.stop="sendEmailDialog = true">
                <v-list-item-title>
                  {{ $t("message.send_email") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="member.allowProfileEdit" @click.stop="showUpdateSocialProfileDialog('fName')">
                <v-list-item-title>
                  {{ $t("message.update_first_name") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="member.allowProfileEdit" @click.stop="showUpdateSocialProfileDialog('lName')">
                <v-list-item-title>
                  {{ $t("message.update_last_name") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="member.allowProfileEdit" @click.stop="showUpdateSocialProfileDialog('email')">
                <v-list-item-title>
                  {{ $t("message.update_email") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop="showUpdateSocialProfileDialog('nationality')">
                <v-list-item-title>
                  {{ $t("message.update_nationality") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop="showUpdateSocialProfileDialog('gender')">
                <v-list-item-title>
                  {{ $t("message.update_gender") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop="showUpdateSocialProfileDialog('dob')">
                <v-list-item-title>
                  {{ $t("message.update_dob") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="member.allowProfileEdit" @click.stop="showUpdateSocialProfileDialog('password')">
                <v-list-item-title>
                  {{ $t("message.reset_password") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop="showUpdateSocialProfileDialog('belt')">
                <v-list-item-title>
                  {{ $t("message.update_belt") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop="showUpdateSocialProfileDialog('isMinor')">
                <v-list-item-title v-if="member && member.isMinor">
                  {{ $t("message.update_to_adult") }}
                </v-list-item-title>
                <v-list-item-title v-else>
                  {{ $t("message.is_minor") }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <image-upload color="primary" :block="true" :label="$t('message.update_profile_image')" class="mt-1"
            :fab="false" :vm="this" :add-small="true" :success-function="successUploadImage">
          </image-upload>
        </div>
      </v-card>
      <v-card class="mt-2" outlined flat v-if="member.lifetimeValue">
        <v-subheader>
          {{ $t("message.lifetime_value") }}
        </v-subheader>
        <div class="text-center text-h5">
          {{ member.currencySymbol }}{{ member.lifetimeValue }}
        </div>
      </v-card>
      <v-card class="mt-2" elevation="0" outlined>
        <v-list class="text-left pa-1">
          <v-subheader>
            {{ $t("message.memberships") }}
          </v-subheader>
          <div v-if="subscriptions.length == 0">
            <v-btn outlined elevation="0" block small color="primary" @click="goToSellMembership()">
              <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
              {{ $t("message.add_membership") }}
            </v-btn>
          </div>
          <template v-for="(i, index) in subscriptions">
            <v-list-item :key="'active_membership_' + i._id" @click="goToTransaction(i)">
              <v-list-item-icon>
                <TransactionIcon :transaction="i"></TransactionIcon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon size="15" color="accent" class="mr-1"
                    v-if="i.coupon && (i.coupon.discountPercent > 0 || i.coupon.discountAmount > 0)">mdi-tag-outline</v-icon>{{ i.product.name }}
                </v-list-item-title>
                <v-list-item-subtitle v-if="i.subscription || i.interval">
                  {{ getIntervalDisplay(i.interval) }} - {{ $t('message.automatic_subscription') }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-else-if="i.subscriptionCheckins">
                  {{ i.checkins }} /
                  {{ i.subscriptionCheckins }} {{ $t('message.checkins') }}</v-list-item-subtitle>
                <v-list-item-subtitle v-else-if="i.subscriptionEndDate">
                  {{ i.expired ? $t('message.expired') : $t('message.expires') }}:
                  {{ $d(new Date(i.subscriptionEndDate), "month_day_year", $i18n.locale) }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="index + 1 < subscriptions.length" :key="'active_membership_divider_' + index"></v-divider>
          </template>
        </v-list>
      </v-card>
      <v-card class="mt-2" elevation="0" outlined>
        <v-list>
          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-label-multiple-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <TagsCombo @input="updateTags" v-model="member.tags" :label="''"></TagsCombo>
              </v-list-item-title>
              <v-list-item-subtitle>{{ $t("message.labels") }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
      <v-expansion-panels class="mt-2" flat v-model="memberPanels" v-if="member">
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header>
            <div class="text-left">
              <v-icon>mdi-alert-outline</v-icon>
              {{ $t("message.alerts") }} ({{ alertsCount }})
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <member-alerts v-if="alerts" :member="memberId" :alerts="alerts" :hide-header="true">
            </member-alerts>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="paymentMethod" v-allowed="'view_purchases'"
          :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header>
            <v-card-text class="pa-0">
              <v-icon>mdi-credit-card-check-outline</v-icon>
              {{ $t("message.payment_method_on_file") }}
            </v-card-text>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card-actions v-if="paymentMethod && paymentMethod.needsUpdate">
              <v-btn outlined elevation="0" block color="primary" x-small @click="updateCOF()">
                <v-icon class="mr-1">mdi-credit-card-refresh-outline</v-icon>
                {{ $t("message.update_payment_method_on_file") }}</v-btn>
            </v-card-actions>
            <v-card-text class="text-center">
              <PaymentMethod :height="60" :payment-method="paymentMethod" :hide-name="true">
              </PaymentMethod>
            </v-card-text>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-allowed="'view_purchases'"
          :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'" v-if="purchases.length > 0">
          <v-expansion-panel-header>
            <v-card-text class="pa-0">
              <v-icon>mdi-cart-outline</v-icon>
              {{ $t("message.purchases") }} ({{ purchases.length }})
            </v-card-text>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card-text class="data-panel">
              <v-list class="text-left">
                <template v-for="(i, index) in purchases">
                  <v-list-item :key="'purchase' + index" @click="goToTransaction(i)" class="pl-0 pr-0">
                    <v-list-item-action class="mr-0 pr-0">
                      <v-list-item-action>
                        <TransactionIcon :transaction="i"></TransactionIcon>
                      </v-list-item-action>
                    </v-list-item-action>
                    <v-list-item-avatar class="mr-1">
                      <ImageDisplay v-if="i.product && i.product.image" :src="i.product.image" />
                      <ImageDisplay v-else-if="i.items && i.items[0] && i.items[0].product && i.items[0].product.image"
                        :src="i.items[0].product.image" />
                      <ImageDisplay v-else-if="i.event && i.event.image" :src="i.event.image" />
                      <v-icon v-else-if="i.product && i.product.type == 'service'"
                        :src="userImg(i.product.image)">mdi-sync</v-icon>
                      <img v-else :src="assets('logo-circular-watermarked.png')" />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        <div v-if="i.product">
                          <v-icon size="15" color="accent" class="mr-1"
                            v-if="i.coupon && (i.coupon.discountPercent > 0 || i.coupon.discountAmount > 0)">mdi-tag-outline</v-icon>{{ i.product.name }}
                          <span class="gray--text ml-1">{{ i.currencySymbol + getTotal(i) }}</span>
                        </div>
                        <div v-else-if="i.items">
                          <v-icon size="15" color="accent" class="mr-1"
                            v-if="i.coupon && (i.coupon.discountPercent > 0 || i.coupon.discountAmount > 0)">mdi-tag-outline</v-icon><span v-if="i.items[0] && i.items.length == 1">{{ i.items[0].name }}</span>
                          <span v-else>{{ i.items.length }} {{ $t('message.items') }}</span>
                          <span class="gray--text ml-1">{{ i.currencySymbol + getTotal(i) }}</span>
                        </div>
                      </v-list-item-title>
                      <v-list-item-subtitle v-if="i.time">
                        {{
                          $d(new Date(i.time), "long", $i18n.locale)
                        }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider v-if="index + 1 < purchases.length" :key="'purchase_divider_' + index"></v-divider>
                </template>
              </v-list>
            </v-card-text>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="expenses && expenses.length > 0" v-allowed="'view_purchases'"
          :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header>
            <v-card-text class="pa-0">
              <v-icon>mdi-hand-coin-outline</v-icon>
              {{ $t("message.expenses") }} ({{ expenses.length }})
            </v-card-text>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card-text class="data-panel">
              <v-list class="text-left">
                <template v-for="(i, index) in expenses">
                  <v-list-item :key="'expense_' + index" @click="goToExpense(i)" class="pl-0 pr-0">
                    <v-list-item-content>
                      <v-list-item-title>
                        <div v-if="i.items">
                          <span v-if="i.items[0]"> {{ i.items[0].name }}</span>
                          <span class="gray--text ml-1">
                            {{ i.currencySymbol + Math.abs(getTotal(i)) }}
                          </span>
                        </div>
                      </v-list-item-title>
                      <v-list-item-subtitle v-if="i.time">
                        {{
                          $d(new Date(i.time), "long", $i18n.locale)
                        }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider v-if="index + 1 < expenses.length" :key="'expense_divider_' + index"></v-divider>
                </template>
              </v-list>
            </v-card-text>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-allowed="'view_purchases'"
          :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header @click="loadRecurrentPayments()">
            <v-card-text class="pa-0">
              <v-icon>mdi-sync</v-icon>
              {{ $t("message.recurrent_payments") }}
            </v-card-text>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-if="loadingRecurrentPayments">
              <v-skeleton-loader class="mx-auto" type="list-item-three-line"></v-skeleton-loader>
            </div>
            <div v-else>
              <v-list v-if="recurrentPayments.length > 0">
                <template v-for="(i, index) in recurrentPayments">
                  <v-list-item :key="'purchase' + index" @click="goToTransactionId(i.transactionId)" class="pl-0 pr-0">
                    <v-list-item-action>
                      <v-chip small :color="getTransactionStatusColor(i.status)">
                        {{ getTransactionStatusText(i.status) }}
                      </v-chip>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ i.subscription }}
                      </v-list-item-title>
                      <v-list-item-subtitle v-if="i.date">
                        {{ $d(new Date(i.date), "long", $i18n.locale) }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider v-if="index + 1 < recurrentPayments.length"
                    :key="'recurrent_payment_divider_' + index"></v-divider>
                </template>
              </v-list>
              <div class="text-body-2" v-else>{{ $t("message.nothing_to_show") }}</div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header @click="loadAttendance()">
            <v-card-text class="pa-0">
              <v-icon>mdi-map-marker-outline</v-icon>
              {{ $t("message.attendance") }}
            </v-card-text>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card elevation="0">
              <div v-if="loadingAttendance">
                <v-skeleton-loader class="mx-auto" type="list-item-three-line"></v-skeleton-loader>
              </div>
              <div v-else>
                <div v-if="attendanceByWeek.data && attendanceByWeek.data.length > 0">
                  <v-subheader>
                    {{ $t("message.by_week") }}
                  </v-subheader>
                  <div v-if="!isSmallerDisplay()">
                    <ApexChart v-if="attendanceByWeek.data" type="bar" :options="attendanceByWeek.options" height="150"
                      :series="attendanceByWeek.data">
                    </ApexChart>
                  </div>
                  <div
                    v-else-if="attendanceByWeek.data && attendanceByWeek.data.length && attendanceByWeek.options && attendanceByWeek.options.xaxis">
                    <v-simple-table>
                      <template v-slot:default>
                        <tbody>
                          <tr v-for="(i, index) in attendanceByWeek.options.xaxis.categories" :key="i">
                            <td>{{ i }}</td>
                            <td>{{ attendanceByWeek.data[0].data[index] }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </div>
                <v-list v-if="attendance.length > 0">
                  <v-subheader>
                    {{ $t("message.last_x", [25]) }}
                    <span class="ml-2" v-if="attendance && attendance.length">({{ roundNumber(onTimeRate) }}% {{
                      $t('message.on_time_rate')
                      }})</span>
                  </v-subheader>
                  <template v-for="(checkin, index) in attendance">
                    <v-list-item :key="checkin._id">
                      <v-list-item-action class="mr-4">
                        <v-icon title="Tablet" v-if="checkin.source == 'tablet'">mdi-tablet</v-icon>
                        <v-icon v-else-if="checkin.source == 'manual'">mdi-desktop-classic</v-icon>
                        <v-icon v-else>mdi-cellphone-sound
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content class="text-left">
                        <v-list-item-title>
                          <v-tooltip top v-if="checkin.isAssistantProfessor">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" size="20"
                                color="accent">mdi-account-supervisor-outline</v-icon>
                            </template>
                            <span>{{ $t("message.assistant_professor") }}</span>
                          </v-tooltip>
                          <v-tooltip top v-else-if="checkin.isProfessor">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" size="20"
                                color="accent">mdi-account-star-outline</v-icon>
                            </template>
                            <span>{{ $t("message.professor") }}</span>
                          </v-tooltip>
                          <span>
                            {{ $d(new Date(checkin.date), "long", $i18n.locale) }}
                          </span>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <span v-if="checkin.name && checkin.name != ''">
                            {{ $t("message.class") }} - {{ checkin.name }}
                          </span>
                          <v-tooltip v-if="checkin.academy && checkin.academy._id != $store.state.selectedAcademy" top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" size="20" color="accent">mdi-bank</v-icon>
                            </template>
                            <span>{{ checkin.academy.name }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="checkin.isLate">
                          <v-icon size="20" color="error">mdi-clock-alert-outline</v-icon>
                          <span class="ml-1 error--text">{{ $t("message.minutes_late", [checkin.isLate]) }}</span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-tooltip v-if="checkin.membershipStatus" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon
                              @click="goToTransactionId(checkin.membershipStatusTransaction)">
                              <v-icon :color="getTransactionStatusColor(checkin.membershipStatus)">
                                mdi-ticket-confirmation-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("message." + checkin.membershipStatus) }}</span>
                        </v-tooltip>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider v-if="index + 1 < attendance.length" :key="'attendance_divider_' + index"></v-divider>
                  </template>
                </v-list>
                <div class="text-body-2" v-else>{{ $t("message.nothing_to_show") }}</div>
              </div>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn elevation="0" @click="goToViewAttendance()">
                  {{ $t("message.view_more") }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="syllabusTemplates && syllabusTemplates.length > 0"
          :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header>
            <div class="text-left">
              <v-icon>mdi-school-outline</v-icon>
              {{ $t("message.syllabus_instances") }} ({{ syllabusInstances ? syllabusInstances.length : 0 }})
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card-actions>
              <v-spacer v-if="!isSmallerDisplay()"></v-spacer>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn outlined elevation="0" color="primary" :block="isSmallerDisplay() ? true : false" v-on="on"
                    small slot="activator" left>
                    <v-icon>mdi-dots-vertical</v-icon>
                    {{ $t("message.actions") }}
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="assignSyllabusDialog = true">
                    <v-list-item-title>
                      {{ $t("message.assign_syllabus") }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="navigateTo({ name: 'viewmemberinactiveinstances', params: { memberid: memberId }, })">
                    <v-list-item-title>
                      {{ $t("message.inactive_curriculums") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card-actions>
            <v-expansion-panels v-model="syllabusInstancesPanel" flat class="bjjlink-card" v-if="syllabusInstances"
              v-allowed="'manage_syllabus_instances'">
              <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'"
                v-for="(i, index) in syllabusInstances" :key="'instance_' + index + '_' + i._id">
                <v-expansion-panel-header @click="getSyllabusInstance(i)">
                  <div>
                    <div>
                      {{ i.syllabusTemplate.name }}
                      <span v-if="i.currentLevel" class="supporting-text ml-2">{{
                        $t("message.current_level") }}: {{ i.syllabusTemplate.useBelts ? $t("message." + i.currentLevel)
                          :
                          i.currentLevel }}</span>
                    </div>
                    <div class="mt-2" v-if="i.completed">
                      <v-icon size="20" color="success" class="mr-1">mdi-flag-checkered</v-icon>
                      {{ $t('message.completed') }}: {{ $d((new Date(i.completed)), "month_day_year", $i18n.locale) }}
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pa-0 ma-0">
                  <div>
                    <div v-if="isSmallerDisplay()">
                      <v-btn outlined block class="mt-1" elevation="0" small color="primary"
                        @click="completeInstanceDialog = true">
                        {{ $t("message.complete") }}
                      </v-btn>
                      <v-btn outlined block class="mt-1" elevation="0" small color="primary" v-if="!i.currentLevel"
                        @click="assignLevelDialog = true">
                        {{ $t("message.set_current_level") }}
                      </v-btn>
                      <v-btn outlined block class="mt-1" elevation="0" small color="primary" v-else
                        @click="assignLevelDialog = true">
                        {{ $t("message.start_new_level") }}
                      </v-btn>
                      <v-btn block class="mt-1" elevation="0" small color="error" @click="deleteInstanceDialog = true">
                        <v-icon class="mr-1">mdi-trash-can-outline</v-icon>{{ $t("message.delete") }}
                      </v-btn>
                    </div>
                    <v-card-actions v-else>
                      <v-spacer></v-spacer>
                      <v-btn outlined elevation="0" small color="primary" @click="completeInstanceDialog = true">
                        {{ $t("message.complete") }}
                      </v-btn>
                      <v-btn outlined elevation="0" small color="primary" v-if="!i.currentLevel"
                        @click="assignLevelDialog = true">
                        {{ $t("message.set_current_level") }}
                      </v-btn>
                      <v-btn outlined elevation="0" small color="primary" v-else @click="assignLevelDialog = true">
                        {{ $t("message.start_new_level") }}
                      </v-btn>
                      <v-btn elevation="0" small color="error" @click="deleteInstanceDialog = true">
                        <v-icon class="mr-1">mdi-trash-can-outline</v-icon>{{ $t("message.delete") }}
                      </v-btn>
                    </v-card-actions>
                    <v-card-text>
                      <v-switch @change="updateInstance(i)" v-model="i.displayOnProfile"
                        :label="$t('message.display_on_profile')"></v-switch>
                      <v-switch v-if="i.displayOnProfile" @change="toggleInstanceShowDetails(i)"
                        v-model="i.displayDetails" :label="$t('message.display_instance_details')">
                      </v-switch>
                    </v-card-text>
                    <v-card-text class="pa-0 ma-0">
                      <v-list v-if="selectedInstance && selectedInstance.data && selectedInstance.data.length > 0">
                        <template v-for="(d, index) in selectedInstance.data">
                          <v-card outlined elevation="0" class="pa-0 ma-0 mb-2"
                            :key="'syllabus_instance_header_' + index + '_' + d._id">
                            <v-subheader>
                              <v-progress-linear v-if="selectedInstance.syllabusTemplate.useBelts"
                                :color="getBeltColorForProgress(d.level)" height="20" :value="d.overallPercent" striped
                                :style="(d.level && d.level.indexOf('white') >= 0 ? 'border: 1px solid gray;' : '') + (selectedInstance.currentLevel == d.level ? '' : 'opacity: 0.5;')">
                                <template v-slot:default="{ value }">
                                  <strong
                                    :class="getProgressTextColor(selectedInstance.currentLevel, true) + '--text'">{{
                                      Math.ceil(value) }}%</strong>
                                </template>
                              </v-progress-linear>
                              <v-progress-linear v-else
                                :color="selectedInstance.colors && selectedInstance.colors[d.level] ? selectedInstance.colors[d.level] : getColor('light')"
                                height="20" :value="d.overallPercent" striped
                                :style="(selectedInstance.colors && selectedInstance.colors[d.level] ? 'color:white;' : '') + (selectedInstance.currentLevel == d.level ? '' : 'opacity: 0.5;')">
                                <template v-slot:default="{ value }">
                                  <strong> {{ d.level }}: {{ Math.ceil(value) }}%</strong>
                                </template>
                              </v-progress-linear>
                            </v-subheader>
                            <v-card-actions class="pa-0 pr-2 justify-end">
                              <v-btn small icon color="error" @click.stop="showDeleteSyllabusLevelDialog(d)"
                                :title="$t('message.delete_level')">
                                <v-icon size="18">mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </v-card-actions>
                            <v-list-item :key="'syllabus_instance_header_started_time_' + index + '_' + d._id"
                              v-if="d.createdOn">
                              <v-list-item-content>
                                <v-list-item-title>
                                  <v-icon size="20" class="mr-1">mdi-ray-start-arrow</v-icon>
                                  {{ $t('message.started') }}: {{ $d((new Date(d.createdOn)), "month_day_year",
                                    $i18n.locale) }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                  {{ $t('message.level') }}:
                                  <span v-if="selectedInstance.syllabusTemplate.useBelts">
                                    <belt-display size="15" :belt="d.level" :show-text="true" />
                                  </span>
                                  <span v-else>{{ d.level }}</span>
                                </v-list-item-subtitle>
                                <v-list-item-subtitle>
                                  {{ $t('message.days_ago', [daysBetween(new Date(), new Date(d.createdOn))]) }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-action>
                                <v-btn @click.stop="showEditSyllabusDataStartDate(d)" small icon>
                                  <v-icon>mdi-calendar-edit-outline</v-icon>
                                </v-btn>
                              </v-list-item-action>
                            </v-list-item>
                            <v-list-item v-if="d.completed"
                              :key="'syllabus_instance_header_completed_time_' + index + '_' + d._id">
                              <v-list-item-content>
                                <v-list-item-title>
                                  <v-icon size="20" color="success" class="mr-1">mdi-flag-checkered</v-icon>
                                  {{ $t('message.completed') }}: {{ $d((new Date(d.completed)), "month_day_year",
                                    $i18n.locale) }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                  {{ $t('message.days_ago', [daysBetween(new Date(), new Date(d.completed))]) }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle>
                                  {{ $t('message.completed_by') }}:
                                  <v-avatar size="20" class="mr-1 ml-1">
                                    <ImageDisplay :src="d.completedBy.userImageSmall" />
                                  </v-avatar>{{ d.completedBy.displayName }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-action>
                                <v-btn @click.stop="showEditSyllabusDataStartDate(d, true)" small icon>
                                  <v-icon>mdi-calendar-edit-outline</v-icon>
                                </v-btn>
                              </v-list-item-action>
                            </v-list-item>
                            <div v-for="(rule, ruleIndex) in d.instanceRules"
                              :key="'syllabus_instance_data_rule_' + ruleIndex + '_' + d._id">
                              <v-list-item @click="doNothing()" class="text-left">
                                <v-list-item-content>
                                  <div v-if="rule.category">
                                    <v-chip outlined x-small color="accent">{{ rule.category }}</v-chip>
                                  </div>
                                  <v-list-item-title>
                                    <span v-if="rule.ruleType == 'checkins'" class="mr-1">
                                      <v-icon size="20">mdi-map-marker-outline</v-icon>
                                      {{ $t('message.regular_checkins') }}
                                    </span>
                                    <span v-else-if="rule.ruleType == 'checkins_contains'" class="mr-1">
                                      <v-icon size="20">mdi-map-marker-outline</v-icon>{{ rule.ruleId }}
                                    </span>
                                    <span v-else-if="rule.ruleType == 'checkins_matches'" class="mr-1">
                                      <v-icon size="20">mdi-map-marker-outline</v-icon>{{ rule.ruleId }}
                                    </span>
                                    <span v-else-if="rule.ruleType == 'number'" class="mr-1">
                                      <v-icon size="20">mdi-chevron-double-up</v-icon>{{ rule.ruleId }}
                                    </span>
                                    <span v-else-if="rule.ruleType == 'boolean'" class="mr-1">
                                      <v-icon size="20">mdi-check-circle-outline</v-icon>{{ rule.ruleId }}
                                    </span>
                                    <span v-else-if="rule.ruleType == 'video'" class="mr-1">
                                      <v-icon size="20">mdi-video-outline</v-icon>{{ rule.ruleId }}
                                    </span>
                                    <span v-else-if="rule.ruleType == 'days'" class="mr-1">
                                      <v-icon size="20">mdi-calendar-clock</v-icon>{{ rule.ruleId }}
                                    </span>
                                    <span v-else-if="rule.ruleType == 'text'" class="mr-1">
                                      <v-icon size="20">mdi-text-box-outline</v-icon>{{ rule.ruleId }}
                                    </span>
                                    <span v-else-if="rule.ruleType == 'flowchart'" class="mr-1">
                                      <v-icon size="20">mdi-sitemap-outline</v-icon>{{ rule.ruleId }}
                                    </span>
                                  </v-list-item-title>
                                  <div v-if="rule.details || rule.text || rule.longText || rule.updatedOn">
                                    <v-btn text x-small class="pl-0"
                                      @click.stop="$set(rule, 'expanded', !rule.expanded)">
                                      <v-icon x-small class="mr-1">{{ rule.expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                      {{ $t('message.details') }}
                                    </v-btn>
                                    <div v-if="rule.expanded" class="text-caption grey--text mt-1 pb-1">
                                      <div v-if="rule.details" class="mb-1">{{ rule.details }}</div>
                                      <div v-if="rule.text" class="mb-1">{{ rule.text }}</div>
                                      <div v-if="rule.longText" class="mb-1">{{ rule.longText }}</div>
                                      <div v-if="rule.updatedOn">
                                        <v-icon size="12" class="mr-1">mdi-clock-outline</v-icon>
                                        <span v-if="rule.ruleType === 'boolean' && rule.booleanValue">{{ $t('message.completed') }}:</span>
                                        <span v-else>{{ $t('message.updated') }}:</span>
                                        {{ $d(new Date(rule.updatedOn), "month_day_year", $i18n.locale) }}
                                      </div>
                                    </div>
                                  </div>
                                </v-list-item-content>
                                <v-list-item-action v-if="selectedInstance.currentLevel == d.level">
                                  <v-text-field hide-details outlined dense v-if="isCheckinsRule(rule.ruleType)"
                                    :disabled="!rule.enableEditing"
                                    @change="updateInstanceDataRules($event, d._id, rule.ruleId)"
                                    v-model="rule.numberValue" :label="'Total: ' + rule.numberNeeded">
                                  </v-text-field>
                                  <div v-else-if="rule.ruleType == 'days'">
                                    {{ rule.numberValue }}/{{ rule.numberNeeded }}
                                  </div>
                                  <v-text-field outlined dense v-else-if="rule.numberValue != null" type="number"
                                    @change="updateInstanceDataRules($event, d._id, rule.ruleId)"
                                    v-model="rule.numberValue" :label="'Total: ' + rule.numberNeeded">
                                  </v-text-field>
                                  <v-switch v-else @change="updateInstanceDataRules($event, d._id, rule.ruleId)"
                                    v-model="rule.booleanValue"></v-switch>
                                </v-list-item-action>
                                <v-list-item-action v-else>
                                  <v-text-field outlined v-if="rule.ruleId == 'checkins'" :disabled="true"
                                    v-model="rule.numberValue" :label="'Total: ' + rule.numberNeeded"></v-text-field>
                                  <v-text-field outlined dense v-else-if="rule.numberValue != null" :disabled="true"
                                    @change="updateInstanceDataRules($event, d._id, rule.ruleId)"
                                    v-model="rule.numberValue" :label="'Total: ' + rule.numberNeeded">
                                  </v-text-field>
                                  <v-text-field outlined dense v-else-if="rule.ruleType == 'days'" :disabled="true"
                                    v-model="rule.numberValue" :label="$t('message.needed') + ': ' + rule.numberNeeded">
                                  </v-text-field>
                                  <v-switch v-else :disabled="true"
                                    @change="updateInstanceDataRules($event, d._id, rule.ruleId)"
                                    v-model="rule.booleanValue"></v-switch>
                                </v-list-item-action>
                              </v-list-item>
                              <div class="pl-2" v-if="rule.ruleType && rule.ruleType.indexOf('checkins') >= 0">
                                <v-switch small v-model="rule.enableEditing"
                                  :label="isSmallerDisplay() ? $t('message.override_checkins') : $t('message.checkin_rules_edit_explained')">
                                </v-switch>
                              </div>
                              <v-divider v-if="ruleIndex + 1 < d.instanceRules.length" :key="ruleIndex"></v-divider>
                            </div>
                          </v-card>
                        </template>
                      </v-list>
                      <div v-else class="supporting-text">
                        {{ $t("message.no_current_level") }}
                      </div>
                    </v-card-text>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="!member.notBjjUser"
          :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header @click="getMemberBeltHistory()">
            <div class="text-left">
              <icon-belt color="grey"></icon-belt>
              {{ $t("message.belt_history") }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list class="text-left">
              <template v-for="(i, index) in beltHistory">
                <v-list-item :key="'belt_history_' + index">
                  <v-list-item-content>
                    <v-list-item-title>
                      <belt-display :belt="i.belt" :show-text="isSmallerDisplay() ? false : true" />
                      <span class="ml-1" v-if="isSmallerDisplay()">{{ displayBeltDay(i.date) }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="i.daysAtRank">
                      {{ $t("message.days_at_belt") }} <b>{{ i.daysAtRank }}</b>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="i.classesAtRank">
                      {{ $t("message.classes_at_rank") }} <b>{{ i.classesAtRank }}</b>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content v-if="!isSmallerDisplay()">
                    <v-list-item-title>
                      {{ displayBeltDay(i.date) }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn @click.stop="deleteMemberBeltHistory(i._id)" small icon>
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="index + 1 < beltHistory.length" :key="'belthistory_divider_' + index"></v-divider>
              </template>
            </v-list>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn outlined elevation="0" color="primary" :block="isSmallerDisplay() ? true : false"
                @click.stop="showUpdateSocialProfileDialog('belt')">
                {{ $t("message.update_belt") }}
              </v-btn>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header @click="getAcademyLists()">
            <div class="text-left">
              <v-icon>mdi-chevron-double-up</v-icon>
              {{ capitalizeFirstLetter($t("message.levels")) }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card-actions v-if="!isSmallerDisplay()">
              <div class="text-caption">
                <v-icon size="15">mdi-information-slab-circle-outline</v-icon>
                {{ $t("message.alternative_levels_explained") }}
              </div>
              <v-spacer></v-spacer>
              <v-btn outlined elevation="0" color="primary" @click="addLevelDialog = true">{{ $t("message.add")
                }}</v-btn>
            </v-card-actions>
            <div v-else>
              <v-btn outlined elevation="0" block color="primary" @click="addLevelDialog = true">{{ $t("message.add")
                }}</v-btn>
            </div>
            <v-card-text>
              <div class="text-center" v-if="alternativeLevels.length == 0">
                {{ $t("message.no_data") }}
              </div>
              <v-list v-else>
                <template v-for="(i, index) in alternativeLevels">
                  <v-list-item :key="'alt_level_' + index">
                    <v-list-item-content class="text-subtitle-1">
                      <v-list-item-title>
                        <v-chip small color="accent">{{ i.sport }} : {{ i.name }}</v-chip>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ $d(new Date(i.date), "month_day_year", $i18n.locale) }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn small icon
                        @click="removeAlternativelevel(i, index)"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-list>
            </v-card-text>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header>
            <div class="text-left">
              <span class="mr-2">
                <v-icon>mdi-account-group-outline</v-icon>
              </span>
              <span class="mt-1">{{ $t("message.family_members") }}</span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card-actions v-if="!guardianUser && !familyUser">
              <v-spacer></v-spacer>
              <v-btn outlined small elevation="0" @click="showNewMemberDialog()" color="primary">
                <v-icon>mdi-plus-circle-outline</v-icon>
                <span v-if="!isSmallerDisplay()">{{ $t("message.add_member") }}</span>
              </v-btn>
            </v-card-actions>
            <div v-if="guardianUser">
              <v-list-item @click="goToMember(member.guardianUser._id)">
                <v-list-item-avatar v-if="member.guardianUser && member.guardianUser.userImageSmall">
                  <ImageDisplay :src="member.guardianUser.userImageSmall" />
                </v-list-item-avatar>
                <v-list-item-action v-else>
                  <v-icon>mdi-account-multiple-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ member.guardianUser.displayName }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ $t("message.guardian") }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon small @click.stop="removeGuardianUser()">
                    <v-icon small>mdi-link-off</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </div>
            <div v-else-if="familyUser">
              <v-list-item>
                <v-list-item-avatar class="clickable" @click="goToMember(member.familyUser._id)"
                  v-if="member.familyUser && member.familyUser.userImageSmall">
                  <ImageDisplay :src="member.familyUser.userImageSmall" />
                </v-list-item-avatar>
                <v-list-item-action v-else>
                  <v-icon>mdi-account-group-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    <MembersAutocomplete :skip-user="memberId" v-on:user_picked="updateFamilyUser" v-model="familyUser">
                    </MembersAutocomplete>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ $t("message.main_family_user") }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
            <div v-else-if="member.familyMembers">
              <template v-for="(i, index) in member.familyMembers">
                <v-list-item :key="'familymember_' + i._id" @click="goToMember(i.userId)">
                  <v-list-item-avatar>
                    <ImageDisplay v-if="i.image" :src="i.image" />
                    <img v-else :src="assets('default-profile-avatar.png')" />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ i.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn @click.stop="removeFamilyMember(i._id)" small icon>
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="index + 1 < member.familyMembers.length"
                  :key="'familymember_divider_' + index"></v-divider>
              </template>
            </div>
            <div v-else class="bg-primary text-center">
              {{ $t("message.nothing_to_show") }}
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'"
          v-if="member.memberData">
          <v-expansion-panel-header>
            <v-card-text class="pa-0">
              <span class="mt-2"><v-icon>mdi-comment-text-outline</v-icon></span>
              {{ $t("message.comments") }}
            </v-card-text>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <member-comments :data="member.memberData" />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-show="true" :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header>
            <div class="text-left">
              <v-icon>mdi-text-box-outline</v-icon>
              {{ $t("message.notes") }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-textarea outlined :placeholder="$t('message.type_to_edit')" @blur="updateMemberData()"
              v-model="member.memberData.notes"></v-textarea>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-show="true" :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header>
            <div class="text-left">
              <v-icon>mdi-account-tie-voice-outline</v-icon>
              {{ $t("message.referral_campaigns") }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list v-if="referralCampaigns && referralCampaigns.length">
              <template v-for="(i, index) in referralCampaigns">
                <v-list-item two-line :key="'affiliate_' + index" @click="goToAffiliate(i)">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ i.campaign }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ i.referrals.length }} {{ $t("message.referrals") }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider v-if="index + 1 < referralCampaigns.length" :key="'affiliate_divider_' + index"></v-divider>
              </template>
            </v-list>
            <v-card-actions>
              <v-btn @click="navigateTo({ name: 'growthcentraltab', params: { tabId: 5 } })" block small outlined
                color="primary">{{ $t("message.add_to_campaign") }}</v-btn>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header @click="getAcademyLists()">
            <div class="text-left">
              <v-icon>mdi-label-multiple-outline</v-icon>
              {{ $t("message.key_value_pairs") }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="text-caption">{{ $t("message.key_value_pairs_explained") }}</div>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-combobox dense outlined hide-details chips v-model="newKeyValuePair.key"
                    :items="availableMemberKeys" :label="$t('message.key')" clearable></v-combobox>
                </v-col>
                <v-col>
                  <v-combobox dense outlined hide-details chips v-model="newKeyValuePair.value"
                    :items="availableMemberValues" :label="$t('message.value')" clearable></v-combobox>
                </v-col>
                <v-col>
                  <v-btn outlined color="primary" small elevation="0"
                    :disabled="!newKeyValuePair.key || !newKeyValuePair.value ? true : false"
                    @click="addNewKeyValuePair()">
                    {{ $t("message.add") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text>
              <template v-for="(entry, index) in member.valuePairs">
                <v-card-actions :key="'key_vaue_pair_' + index">
                  <v-chip small>{{ entry.key }}</v-chip>
                  <span class="text-subtitle-1 ml-1 mr-1">:</span>
                  <v-chip small class="mr-1">{{ entry.value }}</v-chip>
                  <v-spacer></v-spacer>
                  <v-btn small icon class="ml-1" @click="removeKeyValuePair(index)">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </v-card-actions>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-btn outlined elevation="0" color="primary" block small @click="updateKeyValuePairs()">
                {{ $t("message.update") }}
              </v-btn>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'"
          v-if="member.memberData && member.memberData.academyFormExtraFields">
          <v-expansion-panel-header>
            <v-card-text class="pa-0">
              <span class="mt-2"><v-icon>mdi-list-box-outline</v-icon></span>
              {{ $t("message.contact_form_extra_values") }}
            </v-card-text>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <template v-for="(field, index) in member.memberData.academyFormExtraFields">
              <v-card-actions :key="'extra_field_' + index">
                <v-text-field disabled :key="'extra_field_' + index" :label="field.fieldName"
                  v-model="field.value"></v-text-field>
                <v-spacer></v-spacer>
                <v-btn small icon @click="copyToClipboard(field.value)">
                  <v-icon size="25">mdi-content-copy</v-icon>
                </v-btn>
              </v-card-actions>
            </template>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'"
          v-if="pagesCustomFieldsHistory.length > 0">
          <v-expansion-panel-header>
            <v-card-text class="pa-0">
              <span class="mt-2"><v-icon>mdi-file-document-multiple-outline</v-icon></span>
              {{ $t("message.custom_pages_submissions") }}
            </v-card-text>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <template v-for="(pageEntry, pIndex) in pagesCustomFieldsHistory">
              <div :key="'page_entry_' + pIndex" class="mb-4">
                <div class="d-flex justify-space-between align-center px-2">
                  <span class="text-subtitle-2">{{ pageEntry.pageId && pageEntry.pageId.name ? pageEntry.pageId.name :
                    $t('message.custom_page') }}</span>
                  <span class="text-caption grey--text" v-if="pageEntry.submittedOn">{{
                    $d(new Date(pageEntry.submittedOn), 'long', $i18n.locale) }}</span>
                </div>
                <template v-for="(field, fIndex) in pageEntry.values">
                  <v-card-actions :key="'page_entry_' + pIndex + '_field_' + fIndex">
                    <v-text-field disabled :label="field.fieldName" v-model="field.value"></v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn small icon @click="copyToClipboard(field.value)">
                      <v-icon size="25">mdi-content-copy</v-icon>
                    </v-btn>
                  </v-card-actions>
                </template>
                <v-divider v-if="pIndex + 1 < pagesCustomFieldsHistory.length" class="mt-2"></v-divider>
              </div>
            </template>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header>
            <div class="text-left">
              <v-icon>mdi-account-circle-outline</v-icon>
              {{ $t("message.user_information") }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-if="member">
              <v-list class="text-left">
                <v-list-item v-if="member.memberData && member.memberData.joinedDate">
                  <v-list-item-action>
                    <v-icon>mdi-login</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $d(new Date(member.memberData.joinedDate),
                        "month_day_year",
                        $i18n.locale) }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t("message.member_since") }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon
                      @click="member.memberData.joinedDate = new Date(member.memberData.joinedDate); editMemberSinceDialog = true;">
                      <v-icon>mdi-pencil-box-outline</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item v-if="usesGuardianEmail()">
                  <v-list-item-action>
                    <v-icon>mdi-key-outline</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-text-field outlined dense :disabled="true" v-model="member.email"></v-text-field>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t("message.bjjlink_social_email") }}
                      <span class="supporting-text">{{ $t("message.bjjlink_social_email_explained") }}</span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="member && !member.isMinor">
                  <v-list-item-action>
                    <v-icon>mdi-card-account-details-outline</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-switch :label="$t('message.staff')" v-model="member.staff" @change="updateIsStaff()">
                      </v-switch>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t("message.staff_explained") }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <div v-if="member.staff && member.pay">
                  <v-card-text>
                    <div>
                      <v-text-field type="number" outlined dense :label="$t('message.rate_per_class')"
                        @change="updateMemberSalary()" v-model="member.pay.ratePerClass"></v-text-field>
                    </div>
                    <div v-if="member.pay.salary">
                      <v-text-field hide-details type="number" outlined dense :label="$t('message.hourly_salary')"
                        @blur="updateMemberSalary()" v-model="member.pay.salary.amount"></v-text-field>
                    </div>
                  </v-card-text>
                </div>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>mdi-cancel</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-switch :label="$t('message.not_bjj_user')" v-model="member.notBjjUser"
                        @change="updateNotBjjUser()">
                      </v-switch>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>mdi-fingerprint</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-text-field outlined dense :placeholder="$t('message.type_to_edit')" @blur="updateCode()"
                        v-model="member.code"></v-text-field>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{
                        $t("message.checkin_code")
                      }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>mdi-home-variant-outline</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      <locations :hide-label="true" v-model="selectedLocation" :display="member.memberData.address">
                      </locations>
                    </v-list-item-title>
                    <v-list-item-subtitle>{{ $t("message.address") }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>mdi-cellphone-arrow-down-variant</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title v-if="member.hasApp">
                      {{ member.hasApp.os }} - {{ member.hasApp.deviceName }}
                    </v-list-item-title>
                    <v-list-item-title v-else>
                      {{ $t("message.none") }}
                    </v-list-item-title>
                    <v-list-item-subtitle>{{ $t("message.has_connect_app")
                      }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>mdi-lifebuoy</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-text-field outlined dense :placeholder="$t('message.type_to_edit')" @blur="updateMemberData()"
                        v-model="member.memberData.emergencyContact"></v-text-field>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{
                        $t("message.emergency_contact")
                      }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item v-if="!member.guardianUser">
                  <v-list-item-action>
                    <v-icon>mdi-account-group-outline</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-text-field outlined dense :placeholder="$t('message.type_to_edit')" @blur="updateMemberData()"
                        v-model="member.memberData.guardian"></v-text-field>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t("message.guardian") }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="!member.guardianUser">
                  <v-list-item-action>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-text-field outlined dense :placeholder="$t('message.type_to_edit')" @blur="updateMemberData()"
                        v-model="member.memberData.guardianEmail" :rules="[validationRules.email]"></v-text-field>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t("message.guardian_email") }}
                      <span class="supporting-text">
                        {{ $t("message.guardian_email_explained") }}
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>mdi-email-multiple-outline</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-combobox v-model="member.memberData.altEmails" label="Alternative Emails"
                      chips multiple outlined dense deletable-chips small-chips @change="normalizeAndSaveAltEmails()">
                      <template v-slot:selection="data">
                        <v-chip v-bind="data.attrs" :input-value="data.selected" close small
                          color="secondary" dark @click="data.select"
                          @click:close="member.memberData.altEmails.splice(member.memberData.altEmails.indexOf(data.item), 1); updateMemberData()">
                          {{ data.item }}
                        </v-chip>
                      </template>
                    </v-combobox>
                    <v-list-item-subtitle>Alternative Emails</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <div v-if="!loading && !hasFamilyMembers && !familyUser">
                  <v-list-item>
                    <v-list-item-avatar class="clickable" @click="goToMember(member.guardianUser._id)"
                      v-if="member.guardianUser && member.guardianUser.userImageSmall">
                      <ImageDisplay :src="member.guardianUser.userImageSmall" />
                    </v-list-item-avatar>
                    <v-list-item-action v-else>
                      <v-icon>mdi-account-multiple-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        <MembersAutocomplete :skip-user="memberId" v-on:user_picked="updateGuardianUser"
                          v-model="guardianUser">
                        </MembersAutocomplete>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ $t("message.guardina_user") }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-if="member.usesStripe">
                        <v-icon class="mr-1" size="15">mdi-alert</v-icon>
                        {{ $t("message.linking_guardian_explained") }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </div>
                <div v-if="!loading && !hasFamilyMembers && !guardianUser">
                  <v-list-item>
                    <v-list-item-avatar class="clickable" @click="goToMember(member.familyUser._id)"
                      v-if="member.familyUser && member.familyUser.userImageSmall">
                      <ImageDisplay :src="member.familyUser.userImageSmall" />
                    </v-list-item-avatar>
                    <v-list-item-action v-else>
                      <v-icon>mdi-account-group-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        <MembersAutocomplete :skip-user="memberId" v-on:user_picked="updateFamilyUser"
                          v-model="familyUser">
                        </MembersAutocomplete>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ $t("message.main_family_user") }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </div>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>mdi-phone</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-text-field outlined dense placeholder="2402817824" @blur="updatePhone()" :value="member.phone"
                        @input="onPhoneInput($event)" @keypress="digitsOnly($event)" :prefix="memberPhonePrefix"
                        :error-messages="phoneError" :hint="formattedPhone" persistent-hint maxlength="15" type="tel">
                        <template v-slot:prepend-inner v-if="member.academyCountry">
                          <CountryFlag :countryCode="member.academyCountry" size="20" class="mr-1" />
                        </template>
                      </v-text-field>
                    </v-list-item-title>
                    <v-list-item-subtitle>{{ $t("message.phone") }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>mdi-cake-variant-outline</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      <dob-display :dob="member.dob"></dob-display>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t("message.dob") }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item v-if="member.unsubscribed">
                  <v-list-item-action>
                    <v-icon color="error">mdi-account-voice</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t("message.unsubscribed_on", [$d(new Date(member.unsubscribed), "month_day_year",
                        $i18n.locale)])
                      }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t("message.communication") }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider v-if="member.unsubscribed"></v-divider>
                <v-list-item v-if="paymentMethod">
                  <v-list-item-action>
                    <v-icon>mdi-credit-card-check-outline</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title v-if="paymentMethod.needsUpdate">
                      <v-btn outlined elevation="0" color="primary" x-small @click="updateCOF()">{{
                        $t("message.update_card_on_file")
                        }}</v-btn>
                    </v-list-item-title>
                    <v-list-item-title v-else>
                      <credit-card :height="60" :brand="paymentMethod.brand" :hide-name="true"></credit-card>
                      <span class="supporting-text">{{ $t("message.last4") }}: {{ paymentMethod.lastFour }}</span>
                      <span class="supporting-text ml-5" v-if="paymentMethod.expDate">
                        ({{ $t("message.expires") }}:
                        {{
                          $d(paymentMethod.expDate, "month_year", $i18n.locale)
                        }})
                      </span>
                      <span v-if="paymentMethod.expired" class="error--text ml-2">{{ $t("message.expired") }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{
                        $t("message.saved_card")
                      }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action v-if="paymentMethod">
                    <v-btn outlined icon @click="updateCOF()" color="primary">
                      <v-icon>mdi-credit-card-refresh-outline</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  <v-list-item-action v-if="paymentMethod && !paymentMethod.needsUpdate">
                    <v-btn icon @click="deletePaymentMethodDialog = true">
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="paymentMethod"></v-divider>
              </v-list>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-menu offset-y small>
                  <template v-slot:activator="{ on }">
                    <v-btn elevation="0" v-on="on" small slot="activator" color="secondary">
                      <v-icon size="20">mdi-pencil-box-outline</v-icon>
                      {{ $t("message.edit_social_profile") }}
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-if="member.allowProfileEdit || isAppAdmin"
                      @click.stop="showUpdateSocialProfileDialog('fName')">
                      <v-list-item-title>
                        {{ $t("message.update_first_name") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="member.allowProfileEdit || isAppAdmin"
                      @click.stop="showUpdateSocialProfileDialog('lName')">
                      <v-list-item-title>
                        {{ $t("message.update_last_name") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="member.allowProfileEdit || isAppAdmin"
                      @click.stop="showUpdateSocialProfileDialog('email')">
                      <v-list-item-title>
                        {{ $t("message.update_email") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click.stop="showUpdateSocialProfileDialog('nationality')">
                      <v-list-item-title>
                        {{ $t("message.update_nationality") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click.stop="showUpdateSocialProfileDialog('dob')">
                      <v-list-item-title>
                        {{ $t("message.update_dob") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="member.allowProfileEdit || isAppAdmin"
                      @click.stop="showUpdateSocialProfileDialog('password')">
                      <v-list-item-title>
                        {{ $t("message.reset_password") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click.stop="showUpdateSocialProfileDialog('belt')">
                      <v-list-item-title>
                        {{ $t("message.update_belt") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click.stop="showUpdateSocialProfileDialog('isMinor')">
                      <v-list-item-title v-if="member && member.isMinor">
                        {{ $t("message.update_to_adult") }}
                      </v-list-item-title>
                      <v-list-item-title v-else>
                        {{ $t("message.is_minor") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-spacer></v-spacer>
              </v-card-actions>
              <v-card-actions>
                <v-spacer></v-spacer>
                <image-upload color="secondary" :label="$t('message.update_profile_image')"
                  style="margin-right:5px;margin-left:5px" :fab="false" :vm="this" :add-small="true"
                  :success-function="successUploadImage">
                </image-upload>
                <v-spacer></v-spacer>
              </v-card-actions>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header @click="getEmails()">
            <div class="text-left">
              <v-icon>mdi-email-fast-outline</v-icon>
              {{ $t("message.sent_emails") }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content v-if="emails">

            <div v-if="!emails || emails.length == 0" class="text-center text-cubtitle-1 primary--text">
              {{ $t("message.no_member_emails") }}
            </div>
            <v-skeleton-loader v-if="loadingEmails"
              type="list-item-avatar, divider, list-item-avatar, divider, list-item-avatar"></v-skeleton-loader>
            <div class="text-caption" v-else-if="emails.length > 50">{{ $t("message.showing_first_results_only",
              [50]) }}</div>
            <template v-for="(e, index) in emails">
              <v-list-item two-line :key="'update' + index" class="text-left" @click="getEmail(e)">
                <v-list-item-content>
                  <v-list-item-title>
                    <span v-if="e.opening">
                      <v-progress-circular size="15" width="5" indeterminate color="secondary"></v-progress-circular>
                    </span>
                    <span v-else>{{ e.subject }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ $d(new Date(e.time), "long", $i18n.locale) }}
                    <v-icon class="ml-1" size="20" v-if="e.failed" color="error">mdi-email-alert-outline</v-icon>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="e.source == 'sequence-automations'">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="accent" v-bind="attrs" v-on="on" size="20">mdi-robot-industrial-outline</v-icon>
                    </template>
                    <span>{{ $t("message.automations") }}</span>
                  </v-tooltip>
                </v-list-item-action>
                <v-list-item-action>
                  <v-badge color="secondary" :content="e.recipients">
                    <v-icon size="20" v-if="e.recipients == 1">mdi-account-outline</v-icon>
                    <v-icon size="20" v-else-if="e.recipients == 2">mdi-account-multiple-outline</v-icon>
                    <v-icon size="20" v-else>mdi-account-group-outline</v-icon>
                  </v-badge>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="index + 1 < emails.length" :key="index"></v-divider>
            </template>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header @click="getMemberAcademyActivity()">
            <div class="text-left">
              <v-icon>mdi-alert-circle-outline</v-icon>
              {{ $t("message.updates") }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <template v-for="(u, index) in activity">
              <v-list-item two-line :key="'update' + index" class="text-left" @click="viewUpdate(u.value)">
                <v-list-item-avatar>
                  <ImageDisplay v-if="u.user.userImageSmall" :src="u.user.userImageSmall" />
                  <img v-else :src="assets('default-profile-avatar.png')" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      u.user.displayName
                    }}
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="u.time">
                    {{ $d(new Date(u.time), "short", $i18n.locale) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("message.admin_action_" + u.action)
                    }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-title v-if="u.document">
                    {{
                      u.document.name
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="index + 1 < activity.length" :key="'activity_divider_' + index"></v-divider>
            </template>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'"
          v-if="documents.length > 0">
          <v-expansion-panel-header>
            <v-card-text class="pa-0">
              <v-icon>mdi-clipboard-list-outline</v-icon>
              {{ $t("message.documents") }} ({{ documents.length }})
            </v-card-text>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card-text class="data-panel">
              <v-list class="text-left">
                <template v-for="(i, index) in documents">
                  <v-list-item :key="'completed_document_' + index" @click="viewDocument(i)">
                    <v-list-item-content>
                      <v-list-item-title>
                        <span v-if="i.template">{{ i.template.name }}</span>
                        <span v-else>
                          {{
                            $t("message.main_tablet_waiver")
                          }}
                        </span>
                      </v-list-item-title>
                      <v-list-item-subtitle v-if="i.time">
                        <span>
                          {{
                            $d(new Date(i.time), "long", $i18n.locale)
                          }}
                        </span>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-if="i.guardianUser && i.guardianUser._id == memberId">
                        <span>
                          {{
                            $t("message.on_behalf_of")
                          }}
                          {{ i.user.displayName }}
                        </span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-avatar
                      v-if="i.guardianUser && i.user.userImageSmall && i.guardianUser._id == memberId">
                      <ImageDisplay :src="i.user.userImageSmall" />
                    </v-list-item-avatar>
                  </v-list-item>
                  <v-divider v-if="index + 1 < documents.length" :key="'deocument_divider_' + index"></v-divider>
                </template>
              </v-list>
            </v-card-text>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'"
          v-if="member.memberData">
          <v-expansion-panel-header @click="getUploads()">
            <v-card-text class="pa-0">
              <v-icon>mdi-cloud-upload-outline</v-icon>
              {{ $t("message.uploads") }} ({{
                member.memberData.uploads ? member.memberData.uploads.length : 0
              }})
            </v-card-text>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="text-caption">
              <v-icon size="15" class="mr-1">mdi-alert-outline</v-icon>
              {{ $t("message.dont_upload_sensitive_data") }}
            </div>
            <v-card-text class="text-right">
              <input style="display:none" type="file" @change="onFileSelect" ref="fileUploadInput" />
              <v-btn elevation="0" class="outlined-btn" :loading="uploadingFile" :disabled="uploadingFile" small
                @click="$refs.fileUploadInput.click()">
                <v-icon>mdi-cloud-arrow-up-outline</v-icon>
                {{ $t("message.upload_file") }}
              </v-btn>
            </v-card-text>
            <v-card-text class="data-panel">
              <v-list class="text-left">
                <template v-for="(i, index) in uploads">
                  <v-list-item :key="'purchase' + index">
                    <v-list-item-action>
                      <v-icon v-if="getFileIcon(i.fileType) == 'table_view'">mdi-table</v-icon>
                      <v-icon v-else-if="getFileIcon(i.fileType) == 'file_copy'">mdi-table</v-icon>
                      <v-icon v-else-if="getFileIcon(i.fileType) == 'photo'">mdi-image</v-icon>
                      <v-icon v-else-if="getFileIcon(i.fileType) == 'article'">mdi-text-box-outline</v-icon>
                      <v-icon v-else-if="getFileIcon(i.fileType) == 'picture_as_pdf'">mdi-file-pdf-box</v-icon>
                      <ArchiveIcon v-else></ArchiveIcon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        <span>{{ i.fileName }}</span>
                      </v-list-item-title>
                      <v-list-item-title v-if="i.uploaded">
                        <span style="color:gray">
                          {{
                            $d(new Date(i.uploaded), "long", $i18n.locale)
                          }}
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" fab text small slot="activator" left>
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item @click.stop="deleteUploadDialog = true; selectedUploadId = i._id;">
                            <v-list-item-title>
                              <v-icon>mdi-trash-can-outline</v-icon>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!isSmallerDisplay()" @click.stop="getUploadedFile(i)">
                            <v-list-item-title>
                              <v-icon>mdi-cloud-download-outline</v-icon>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider v-if="index + 1 < uploads.length" :key="'upload_divider_' + index"></v-divider>
                </template>
              </v-list>
            </v-card-text>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined elevation="0" class="mt-6" small v-allowed="'reject_member'" @click="removeMemberDialog = true">
          <v-icon size="20" color="error" class="mr-1">mdi-account-remove-outline</v-icon>
          {{ $t("message.remove_member_from_academy") }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </div>
    <v-dialog v-model="deletePaymentMethodDialog" max-width="80%">
      <v-card class="pa-2" elevation="0" outlined>
        <v-card-text>
          <h3>{{ $t("message.are_you_sure") }}</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn small elevation="0" color="error" @click="deletePaymentMethod()">
            {{
              $t("message.delete")
            }}
          </v-btn>
          <v-btn small elevation="0" class="outlined-btn" @click.stop="
            deletePaymentMethodDialog = false;
          ">{{ $t("message.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteUploadDialog" max-width="80%">
      <v-card class="pa-2">
        <v-card-text>
          <h3>{{ $t("message.are_you_sure") }}</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn small elevation="0" color="error" @click="removeUploadedFile(true)">
            {{
              $t("message.delete")
            }}
          </v-btn>
          <v-btn small elevation="0" class="outlined-btn" @click.stop="
            deleteUploadDialog = false;
          selectedUploadId = null;
          ">{{ $t("message.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="assignSyllabusDialog" max-width="90%">
      <v-card class="text-xs-left" elevation="0" outlined>
        <v-card-title>
          <v-autocomplete outlined v-model="selectedSyllabus" :items="syllabusTemplates" item-text="text"
            :label="$t('message.select_syllabus')" item-value="value" clearable></v-autocomplete>
        </v-card-title>
        <v-card-actions>
          <v-btn outlined small elevation="0" color="primary" @click="assignSyllabusToMember()">{{
            $t("message.assign")
            }}</v-btn>
          <v-btn small elevation="0" @click="assignSyllabusDialog = false">{{
            $t("message.cancel")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="assignLevelDialog" max-width="80%">
      <v-card class="text-xs-left" v-if="selectedTemplate" elevation="0" outlined>
        <v-card-text>
          <div>
            <v-switch v-if="member && member.isMinor" v-model="useMonthlySystem"
              :label="$t('message.kids_monthly_system')"></v-switch>
          </div>
          <BeltsSelectMonthly v-if="useMonthlySystem" :belts="selectedTemplate.levelsPicker" v-model="levelToAssign">
          </BeltsSelectMonthly>
          <BeltsSelect v-else-if="selectedTemplate.useBelts" :belts="selectedTemplate.levelsPicker"
            v-model="levelToAssign">
          </BeltsSelect>
          <v-autocomplete outlined v-else v-model="levelToAssign" :items="selectedTemplate.levelsPicker"
            item-text="text" :label="$t('message.select_level')" item-value="value" clearable></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined small elevation="0" color="primary" @click="assignLevel()">{{
            $t("message.update")
            }}</v-btn>
          <v-btn small elevation="0" @click="assignLevelDialog = false">{{
            $t("message.cancel")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteInstanceDialog" max-width="80%">
      <v-card class="text-xs-left pa-1" v-if="selectedInstance">
        <v-card-text>
          <h1>{{ $t("message.are_you_sure") }}</h1>
          <h3>{{ $t("message.cant_be_undone") }}</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn small elevation="0" color="error" @click="deleteInstance()">{{
            $t("message.delete")
            }}</v-btn>
          <v-btn small elevation="0" class="outlined-btn" @click="deleteInstanceDialog = false">{{
            $t("message.cancel")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteSyllabusLevelDialog" max-width="80%">
      <v-card class="text-xs-left pa-1" v-if="syllabusLevelToDelete">
        <v-card-text>
          <h1>{{ $t("message.are_you_sure") }}</h1>
          <h3>{{ $t("message.cant_be_undone") }}</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn small elevation="0" color="error" :loading="deletingSyllabusLevel" @click="deleteSyllabusLevel()">{{
            $t("message.delete")
            }}</v-btn>
          <v-btn small elevation="0" class="outlined-btn" @click="deleteSyllabusLevelDialog = false">{{
            $t("message.cancel")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="removeMemberDialog" max-width="80%">
      <v-card class="text-xs-left pa-1" v-if="memberId" elevation="0" outlined>
        <v-card-text>
          <h1>{{ $t("message.are_you_sure") }}</h1>
        </v-card-text>
        <v-card-text>
          <v-textarea outlined v-model="cancellationReason" :label="$t('message.reason')"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn small elevation="0" color="error" @click="rejectMember()">{{
            $t("message.remove")
            }}</v-btn>
          <v-btn small elevation="0" class="outlined-btn" @click="removeMemberDialog = false">{{
            $t("message.cancel")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editSocialProfileDialog" max-width="80%">
      <v-card class="text-xs-left pa-1" v-if="socialProfileUpdateData" elevation="0" outlined>
        <v-card-title>
          {{ socialProfileUpdateData.title }}
        </v-card-title>
        <v-card-text>
          <v-switch v-if="socialProfileUpdateData.attribute == 'isMinor'" v-model="socialProfileUpdateData.value">
          </v-switch>
          <div v-else-if="socialProfileUpdateData.attribute == 'dob'">
            <div class="text-subtitle-2">{{ $t('message.dob') }}</div>
            <DatePicker :show-time="false" v-model="socialProfileUpdateData.date" :past-event="true">
            </DatePicker>
          </div>
          <div v-else-if="socialProfileUpdateData.attribute == 'belt'">
            <v-switch v-if="member && member.isMinor" v-model="useMonthlySystem"
              :label="$t('message.kids_monthly_system')"></v-switch>
            <BeltsSelectMonthly v-if="useMonthlySystem" v-model="socialProfileUpdateData.value"></BeltsSelectMonthly>
            <belts-select v-else v-model="socialProfileUpdateData.value" :show-icon="false" />
            <div class="text-subtitle-2">{{ $t('message.date_given') }}</div>
            <DatePicker :show-time="false" v-model="socialProfileUpdateData.date" :past-event="true">
            </DatePicker>
          </div>
          <div v-else-if="socialProfileUpdateData.attribute == 'nationality'">
            <countries-select v-model="socialProfileUpdateData.value" />
          </div>
          <div v-else-if="socialProfileUpdateData.attribute == 'gender'">
            <gender-select v-model="socialProfileUpdateData.value" />
          </div>
          <v-text-field outlined v-else v-model="socialProfileUpdateData.value" :label="$t('message.enter_new_value')">
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined :loading="updatingSocialProfile" small elevation="0" color="primary"
            @click="updateSocialProfile()">{{
              $t("message.update")
            }}</v-btn>
          <v-btn small elevation="0" @click="editSocialProfileDialog = false; socialProfileUpdateData = null">{{
            $t("message.cancel")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="sendNotiDialog" max-width="90%">
      <v-card class="text-xs-left" elevation="0" outlined>
        <v-card-title>
          <v-text-field dense outlined maxlength="50" :label="$t('message.subject')" v-model="subject"></v-text-field>
        </v-card-title>
        <div class="mx-6">
          <v-textarea outlined v-model="notificationContents" rows="5" maxlength="250"></v-textarea>
          <span class="supporting-text">{{ $t('message.mobile_notification_explained') }}</span>
        </div>
        <v-card-actions class="mt-4">
          <v-btn outlined small elevation="0" color="primary" @click="sendNotificationToMember()">{{
            $t("message.send")
            }}</v-btn>
          <v-btn small elevation="0" @click="closeSendNotiDialog()">{{
            $t("message.cancel")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="sendEmailDialog" max-width="90%">
      <v-card class="text-xs-left" elevation="0" outlined>
        <v-card-title>
          {{ $t('message.send_email_to') }}: <b>{{ member ? member.displayName : '' }}</b>
        </v-card-title>
        <v-card-text>
          <v-text-field outlined dense :label="$t('message.subject')" v-model="emailSubject"></v-text-field>
        </v-card-text>
        <v-card-text>
          <v-combobox v-model="customEmails" :label="$t('message.custom_email_addresses')"
            :hint="$t('message.custom_emails_hint')" persistent-hint chips multiple outlined dense deletable-chips
            small-chips :error-messages="emailErrors" @input="validateEmails">
            <template v-slot:selection="data">
              <v-chip v-bind="data.attrs" :input-value="data.selected" close small
                :color="isValidEmail(data.item) ? 'secondary' : 'error'" dark @click="data.select"
                @click:close="removeEmail(data.item)">
                {{ data.item }}
              </v-chip>
            </template>
          </v-combobox>
        </v-card-text>
        <v-card-text>
          <v-textarea outlined v-model="emailContents" :label="$t('message.email_body')" rows="6"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined :loading="sendingEmail" small elevation="0" color="primary" :disabled="!canSendEmail"
            @click="sendEmailToMember()">
            {{ $t("message.send") }}
          </v-btn>
          <v-btn small elevation="0" @click="closeSendEmailDialog()">
            {{ $t("message.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="completeInstanceDialog" max-width="90%">
      <v-card class="text-left" elevation="0" outlined v-if="selectedInstance">
        <v-card-title>
          {{ $t("message.please_confirm") }}
        </v-card-title>
        <v-card-actions>
          <v-btn outlined v-if="selectedInstance.active" small elevation="0" color="primary"
            @click="completeInstance()">{{
              $t("message.complete")
            }}</v-btn>
          <v-btn outlined v-else small elevation="0" color="primary" @click="completeInstance()">{{
            $t("message.activate")
            }}</v-btn>
          <v-btn small elevation="0" @click="completeInstanceDialog = false">{{
            $t("message.cancel")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editSyllabusDataStartDateDialog" max-width="90%">
      <v-card class="text-left" elevation="0" outlined v-if="selectedInstance && selectedInstance.selectedData">
        <v-card-text>
          <DatePicker v-if="selectedInstance.selectedData.editingComplete" :show-time="false"
            v-model="selectedInstance.selectedData.completed" :past-event="true">
          </DatePicker>
          <DatePicker v-else :show-time="false" v-model="selectedInstance.selectedData.createdOn" :past-event="true">
          </DatePicker>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined v-if="selectedInstance.selectedData" small elevation="0" color="primary"
            @click="updateSyllabusDataStartDate()">{{
              $t("message.update")
            }}</v-btn>
          <v-btn small elevation="0" @click="editSyllabusDataStartDateDialog = false">{{
            $t("message.cancel")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addLevelDialog" max-width="90%">
      <v-card class="text-left" elevation="0" outlined>
        <v-card-title>
          {{ $t("message.add_new_level") }}
        </v-card-title>
        <v-card-text>
          <v-combobox :label="$t('message.level')" v-model="newLevel.name" :items="availableLevels"
            :hide-no-data="!levelSearch" :search-input.sync="levelSearch" small-chips outlined dense>
            <template slot="no-data">
              <v-list-item>
                <span class="subheading">{{ $t("message.click_enter_add_new") }}:</span>
                <v-chip class="mr-1" label small>{{ levelSearch }}</v-chip>
              </v-list-item>
            </template>
          </v-combobox>
          <v-combobox :label="$t('message.sport')" v-model="newLevel.sport" :items="availableSports"
            :hide-no-data="!sportSearch" :search-input.sync="sportSearch" small-chips outlined dense>
            <template slot="no-data">
              <v-list-item>
                <span class="subheading">{{ $t("message.click_enter_add_new") }}:</span>
                <v-chip class="mr-1" label small>{{ sportSearch }}</v-chip>
              </v-list-item>
            </template>
          </v-combobox>
          <DatePicker :show-time="false" v-model="newLevel.date" :past-event="true"></DatePicker>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined small elevation="0" color="primary" @click="addNewLevel()">{{
            $t("message.add")
            }}</v-btn>
          <v-btn small elevation="0" @click="addLevelDialog = false">{{
            $t("message.cancel")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addNewMemberDialog" max-width="90%">
      <div class="elevation-5" outlined>
        <v-card>
          <h2 class="ml-4 mt-2">{{
            $t("message.member")
            }}</h2>
          <v-card-text class="mb-0 pb-0">
            <v-switch :disabled="newFamilyMember ? true : false" :label="$t('message.new_user')"
              v-model="existingFamilyMember"></v-switch>
          </v-card-text>
          <v-card-text v-if="!existingFamilyMember" class="mb-0 pb-0">
            <MembersAutocomplete :skip-user="memberId" :label="$t('message.existing_member')" v-model="newFamilyMember">
            </MembersAutocomplete>
            <v-alert type="info" v-if="member && member.usesStripe">
              {{ $t('message.linking_familymember_explained') }}
            </v-alert>
          </v-card-text>
          <v-card-text v-else>
            <div class="pl-4 pr-4 pt-2 pb-2">
              <v-form ref="form">
                <v-switch :label="$t('message.not_bjj_user')" v-model="newUser.notBjjUser"></v-switch>
                <v-switch @change="updateNewMinorEmail()" style="display:inline-block" :label="$t('message.is_minor')"
                  v-model="newUser.isMinor">
                </v-switch>
                <v-icon v-if="newUser.isMinor" :color="themeColor('primary')"
                  class="ml-2 mb-2">mdi-baby-face-outline</v-icon>
                <v-icon v-else-if="newUser.notBjjUser" :color="themeColor('primary')"
                  class="ml-2 mb-2">mdi-account-remove-outline</v-icon>
                <v-text-field :label="$t('message.first_name')" v-model="newUser.fName" autocomplete="false" required
                  outlined dense></v-text-field>
                <v-text-field :label="$t('message.last_name')" v-model="newUser.lName" required outlined dense>
                </v-text-field>
                <v-text-field label="Email" v-model="newUser.email" required outlined dense></v-text-field>
                <GenderSelect :icon="false" v-model="newUser.gender"
                  v-show="!newUser.existing || !newUser.existing.gender" />
                <div v-show="newUser.existing || newUser.isMinor ? false : true">
                  <v-text-field type="password" :label="$t('message.password')" v-model="newUser.password"
                    autocomplete="new-password" required outlined dense></v-text-field>
                  <div class="text-caption mt-n3 mb-3">{{ $t('message.password_access_explained') }}</div>
                </div>
                <BeltsSelect v-if="!newUser.notBjjUser" v-model="newUser.belt"
                  v-show="!newUser.existing || !newUser.existing.belt" />
                <v-card-text class="mt-0 pl-0 pt-0">
                  <div class="text-subtitle-2">{{ $t('message.birthday') }}</div>
                  <DatePicker :show-time="false" v-model="newUser.dob" :past-event="true">
                  </DatePicker>
                </v-card-text>
                <countries-select v-model="newUser.nationality"
                  v-show="!newUser.existing || !newUser.existing.nationality" />
                <v-switch :disabled="newUser.isMinor" :label="$t('message.old_enough')" v-model="newUser.ageMin">
                </v-switch>
                <div v-html="newUserError" class="registration-error"></div>
              </v-form>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined small class="ml-2" elevation="0" @click="addFamilyMember" color="primary"
              :disabled="!newUserReady()">
              <span v-show="!registring">
                {{ $t("message.add_member") }}
              </span>
              <v-progress-circular v-show="registring" indeterminate color="white"></v-progress-circular>
            </v-btn>
            <v-btn small elevation="0" @click="addNewMemberDialog = false; newUser = {}">
              <span>{{ $t("message.close") }}</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
    <v-dialog class="pa-0 ma-0" v-model="timelineDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card dark class="text-left pa-0 ma-0" elevation="0" outlined>
        <v-toolbar dense flat class="opposite--text" color="primary" light>
          <span>{{ $t("message.mei") }}: <b>{{ meiScore }}</b></span>
          <v-spacer></v-spacer>
          <v-btn color="opposite" icon small @click="timelineDialog = false">
            <v-icon>mdi-close-box-outline</v-icon>
          </v-btn>
        </v-toolbar>
        <div>
          <v-timeline align-top>
            <v-timeline-item dark v-for="(item, i) in activityTimeline" :key="'timeline_' + i" :color="item.color"
              fill-dot>
              <template v-slot:icon>
                <IconOss color="opposite" style="margin-bottom:1px" v-if="item.activity == 'react_post'"></IconOss>
                <v-icon color="opposite" v-else-if="item.icon">{{ item.icon }}</v-icon>
                <v-icon color="opposite" v-else>mdi-account-circle-outline</v-icon>
              </template>
              <v-card outlined elevation="0" class="pa-0">
                <v-card-title class="text-h6 pa-0">
                  {{ item.title }}
                </v-card-title>
                <v-card-text class="pa-0">
                  <div>{{ $d(new Date(item.date), "month_day_year", $i18n.locale) }}</div>
                  <div v-if="item.className">{{ item.className }}</div>
                  <div v-if="item.itemName">{{ item.itemName }}</div>
                  <div v-if="item.paymentType">{{ $t("message." + item.paymentType) }}</div>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editMemberSinceDialog" max-width="80%">
      <v-card class="text-xs-left pa-1" v-if="member && member.memberData" elevation="0" outlined>
        <v-card-title>
          {{ $t("message.member_since") }}
        </v-card-title>
        <v-card-text>
          <DatePicker :show-time="false" v-model="member.memberData.joinedDate" :past-event="true">
          </DatePicker>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined :loading="updatingSocialProfile" small elevation="0" color="primary"
            @click="updateMemberSince()">{{
              $t("message.update")
            }}</v-btn>
          <v-btn small elevation="0" @click="editMemberSinceDialog = false;">{{
            $t("message.cancel")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="emailDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card outlined>
        <v-toolbar dense flat class="opposite--text" color="primary">
          <v-spacer></v-spacer>
          <v-btn icon small @click="
            emailDialog = false;
          email = null;
          ">
            <v-icon color="opposite">mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card v-if="email" class="pa-2">
          <v-card-actions style="color:gray">
            <v-avatar size="20">
              <ImageDisplay v-if="email.sender && email.sender.userImageSmall" :src="email.sender.userImageSmall" />
              <img v-else :src="assets('default-profile-avatar.png')" />
            </v-avatar>
            <span v-if="email.sender" class="ml-1">
              {{ email.sender.displayName }}
            </span>
            <v-spacer></v-spacer>
            {{ $d(new Date(email.time), "short", $i18n.locale) }}
          </v-card-actions>
          <v-card-title v-if="email.error" class="text-caption error--text">
            {{ email.error }}
          </v-card-title>
          <v-card class="pa-2" outlined>
            <v-card-title>
              <span class="text-subtitle-1">{{ $t("message.recipients") }}:</span>
              <template v-for="(r, index) in email.recipients">
                <v-chip :key="'recipient' + index" v-if="r && r != ''" small class="ma-1">{{ r }}</v-chip>
              </template>
            </v-card-title>
            <v-card-title>
              <span class="text-subtitle-1">{{ $t("message.subject") }}:</span>
              <span style="margin-left:5px">{{ email.subject }}</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text v-html="email.contents"></v-card-text>
          </v-card>
          <v-card outlined class="mt-1" v-if="email.openedBy && email.openedBy.length">
            <v-card-title>
              <span class="text-subtitle-1">{{ $t("message.opened_by") }}:</span>
            </v-card-title>
            <v-list>
              <v-list-item dense v-for="i in email.openedBy" :key="'opened_email_' + i._id" @click="doNothing()">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ i.user ? i.user.email : i.email }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ $d(new Date(i.time), "long", $i18n.locale) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BeltDisplay from "@/components/displays/BeltDisplay.vue";
import CountryFlag from "@/components/displays/CountryFlagDisplay.vue";
import CreditCard from "@/components/displays/CreditCardDisplay.vue";
import DobDisplay from "@/components/displays/DobDisplay.vue";
import IconBelt from "@/components/displays/icons/IconBelt.vue";
import IconOss from "@/components/displays/icons/IconOss.vue";
import MemberAlerts from "@/components/displays/MemberAlertsDisplay.vue";
import MemberComments from "@/components/displays/MemberComments.vue";
import PaymentMethod from "@/components/displays/PaymentMethodDisplay.vue";
import TransactionIcon from "@/components/displays/TransactionIcon.vue";
import UserDisplay from "@/components/displays/UserDisplay.vue";
import BeltsSelect from "@/components/inputs/BeltSelect.vue";
import BeltsSelectMonthly from "@/components/inputs/BeltSelectMonthly.vue";
import CountriesSelect from "@/components/inputs/CountriesSelect.vue";
import DatePicker from "@/components/inputs/DateTimePicker.vue";
import GenderSelect from "@/components/inputs/GenderSelect.vue";
import ImageUpload from "@/components/inputs/ImageUploadCroppie.vue";
import Locations from "@/components/inputs/LocationsAutocomplete.vue";
import MembersAutocomplete from "@/components/inputs/MembersAutocomplete.vue";
import TagsCombo from "@/components/inputs/TagsCombo.vue";
import Api from "@/services/Api";
import Api2 from "@/services/Api2";
import { formatPhoneInternational, getCallingCode, isValidPhone, normalizePhone, parsePhone } from "@/services/PhoneService";
import ApexChart from 'vue-apexcharts';

export default {
  components: {
    UserDisplay,
    ApexChart,
    MemberAlerts,
    MemberComments,
    CountriesSelect,
    CountryFlag,
    CreditCard,
    DobDisplay,
    BeltsSelect,
    IconBelt,
    BeltDisplay,
    BeltsSelectMonthly,
    ImageUpload,
    GenderSelect,
    Locations,
    MembersAutocomplete,
    DatePicker,
    TagsCombo,
    IconOss,
    TransactionIcon,
    PaymentMethod
  },
  data() {
    return {
      memberId: this.$route.params.memberid,
      syllabusInstanceId: this.$route.query.si,
      sectionSelector: this.$route.query.section,
      sessionId: this.$route.query.s,
      sessionStatus: this.$route.query.status,
      cardOnFile: null,
      loading: true,
      memberError: false,
      member: null,
      phoneError: "",
      formattedPhone: "",
      selectedLocation: null,
      addLevelDialog: null,
      newLevel: {},
      levelSearch: null,
      alternativeLevels: [],
      availableSports: [],
      availableLevels: [],
      sportSearch: null,
      subscriptions: [],
      purchases: [],
      expenses: [],
      loadingRecurrentPayments: false,
      recurrentPayments: [],
      attendance: [],
      attendanceByWeek: {},
      loadingAttendance: false,
      documents: [],
      updatingSocialProfile: false,
      uploading: false,
      uploadingFile: false,
      visitorData: null,
      alerts: null,
      selectedUploadId: null,
      nonMember: null,
      rejected: null,
      selectedFile: null,
      guardianUser: null,
      hasFamilyMembers: false,
      familyUser: null,
      deleteUploadDialog: false,
      removeMemberDialog: false,
      sendNotiDialog: false,
      sendEmailDialog: false,
      sendingEmail: false,
      emailSubject: "",
      emailContents: "",
      customEmails: [],
      emailErrors: [],
      newUser: {},
      timelineDialog: null,
      meiScore: 0,
      loadingTimeline: false,
      activityTimeline: [],
      newFamilyMember: null,
      existingFamilyMember: false,
      newUserError: null,
      registring: false,
      alertsCount: 0,
      activity: [],
      memberPanels: null,
      syllabusInstancesPanel: null,
      deletePaymentMethodDialog: false,
      isMember: false,
      isBirthday: false,
      uploads: [],
      referralCampaigns: [],
      beltHistory: null,
      tagsSearch: null,
      rejectedData: null,
      previousData: {},
      paymentMethod: null,
      onTimeRate: null,
      syllabusInstances: null,
      assignSyllabusDialog: false,
      deleteInstanceDialog: false,
      deleteSyllabusLevelDialog: false,
      syllabusLevelToDelete: null,
      deletingSyllabusLevel: false,
      addNewMemberDialog: null,
      assignLevelDialog: false,
      editMemberSinceDialog: null,
      selectedSyllabus: null,
      syllabusTemplates: null,
      selectedTemplate: null,
      selectedInstance: null,
      notificationContents: null,
      subject: null,
      levelToAssign: null,
      canLevelUp: false,
      editSocialProfileDialog: false,
      cancellationReason: null,
      completeInstanceDialog: false,
      editSyllabusDataStartDateDialog: false,
      socialProfileUpdateData: null,
      isInfinicept: false,
      availableMemberKeys: [],
      availableMemberValues: [],
      newKeyValuePair: {},
      useMonthlySystem: false,
      email: null,
      emailDialog: false,
      loadingEmails: false,
      emails: [],
      successUploadImage: function (uploadedFileData, vm) {
        if (vm && uploadedFileData) {
          vm.submitUpdatePicture(uploadedFileData);
        }
      },
      dateRules: [
        (v) => !!v || '',
        (v) =>
          /(19|20)\d\d([- /.])(0[1-9]|1[012])\2(0[1-9]|[12][0-9]|3[01])/.test(
            v
          ) || this.$t("message.dob_format"),
      ],
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.memberId = to.params.memberid;
    this.member = null;
    this.syllabusInstanceId = null;
    this.selectedInstance = null;
    this.levelToAssign = null;
    this.syllabusInstancesPanel = null;
    this.beltHistory = null;
    this.loadMemberProfile();
    this.memberPanels = null;
    next();
  },
  created() {
    this.loadMemberProfile();
    if (this.sessionId && this.sessionStatus == "success") {
      this.completeCOFUpdate(this.sessionId);
    }
    if (this.syllabusInstanceId || this.sectionSelector == 'lms') {
      this.memberPanels = 4;
    } else if (this.sectionSelector == 'alerts') {
      this.memberPanels = 0;
    }
  },
  watch: {
    selectedLocation: {
      immediate: false,
      handler: function () {
        this.updateMemberAddress();
      }
    },
  },
  computed: {
    pagesCustomFieldsHistory() {
      if (!this.member.memberData || !this.member.memberData.pagesCustomFields) return [];
      return [...this.member.memberData.pagesCustomFields].reverse();
    },
    canSendEmail() {
      const hasValidRecipients = this.memberId || (this.customEmails && this.customEmails.length > 0 && this.emailErrors.length === 0);
      return hasValidRecipients && this.emailSubject && this.emailContents;
    },
    memberPhonePrefix() {
      if (this.member && this.member.academyCountry) {
        const code = getCallingCode(this.member.academyCountry);
        if (code) return "+" + code;
      }
      if (this.member && this.member.phoneCode) {
        return "+" + this.member.phoneCode;
      }
      return "";
    },
  },
  methods: {
    goToExpense(item) {
      this.navigateTo({ name: 'manageexpense', params: { transactionId: item._id } });
    },
    updateMemberSince() {
      Api()
        .patch("admins/managedacademy/" + this.$store.state.managedAcademy + "/member/" + this.memberId + '/member-since',
          { joinedDate: this.member.memberData.joinedDate })
        .then(() => {
          this.showAlert("success", this.$t('message.updated'));
          this.editMemberSinceDialog = false;
        })
        .catch(() => {
          this.showAlert("error", this.$t('message.error_generic'));
        });
    },
    goToAffiliate(i) {
      if (i)
        this.navigateTo({
          name: 'manageaffiliate',
          params: { id: i._id },
        })
    },
    getReferralCampains() {
      Api2()
        .get(
          "referrals/managedacademy/" +
          this.$store.state.managedAcademy +
          "/affiliates/member/" + this.memberId
        )
        .then((response) => {
          if (response && response.data) {
            this.referralCampaigns = response.data.campaigns;
          }
        });
    },
    showEditSyllabusDataStartDate(d, completed) {
      this.selectedInstance.selectedData = d;
      this.selectedInstance.selectedData.createdOn = new Date(d.createdOn);
      if (completed) {
        this.selectedInstance.selectedData.completed = new Date(d.completed);
        this.selectedInstance.selectedData.editingComplete = true;
      } else {
        this.selectedInstance.selectedData.editingComplete = false;
      }
      this.editSyllabusDataStartDateDialog = true;
    },
    updateSyllabusDataStartDate() {
      let patchData = {};
      if (this.selectedInstance.selectedData.editingComplete) {
        patchData.completed = this.selectedInstance.selectedData.completed;
      } else {
        patchData.createdOn = this.selectedInstance.selectedData.createdOn;
      }
      Api()
        .patch(
          "syllabus/managedacademy/" + this.$store.state.managedAcademy +
          "/instance/" + this.selectedInstance._id + "/data/" + this.selectedInstance.selectedData._id + "/created-on",
          patchData
        )
        .then(() => {
          this.selectedInstance.selectedData = null;
          this.editSyllabusDataStartDateDialog = false;
          this.showAlert("success", this.$t("message.updated"));
        })
        .catch(() => {
          this.showAlert("error", this.$t('message.error_generic'));
        });
    },
    getAcademyLists() {
      Api2()
        .get(
          "admins/managedacademy/" +
          this.$store.state.managedAcademy +
          "/lists"
        )
        .then((response) => {
          if (response && response.data) {
            this.availableLevels = response.data.levels;
            this.availableSports = response.data.sports;
            this.availableMemberKeys = response.data.keys;
            this.availableMemberValues = response.data.values;
          }
        });
    },
    removeAlternativelevel(level, index) {
      Api()
        .delete(
          "admins/managedacademy/" + this.$store.state.managedAcademy + "/members/" + this.memberId + "/levels/" + level._id
        )
        .then(() => {
          this.alternativeLevels.splice(index, 1);
        })
        .catch(() => {
          this.showAlert("error", this.$t('message.error_generic'));
        });
    },
    addNewLevel() {
      if (!this.newLevel.date)
        this.newLevel.date = new Date();
      Api()
        .patch(
          "admins/managedacademy/" + this.$store.state.managedAcademy + "/members/" + this.memberId + "/levels",
          { level: this.newLevel }
        )
        .then(() => {
          this.alternativeLevels.push(this.newLevel);
          this.addLevelDialog = false;
          this.newLevel = {};
        })
        .catch(() => {
          this.showAlert("error", this.$t('message.error_generic'));
        });

    },
    addNewKeyValuePair() {
      this.member.valuePairs.push(this.newKeyValuePair);
      this.newKeyValuePair = { key: null, value: null };
    },
    removeKeyValuePair(index) {
      this.member.valuePairs.splice(index, 1);
    },
    updateKeyValuePairs() {
      Api()
        .patch(
          "admins/managedacademy/" + this.$store.state.managedAcademy + "/members/" + this.memberId + "/key-values",
          { valuePairs: this.member.valuePairs }
        )
        .then(() => {
          this.showAlert("success", this.$t("message.updated"));
        })
        .catch(() => {
          this.showAlert("error", this.$t('message.error_generic'));
        });
    },
    getActivityTimeline(more) {
      this.loadingTimeline = true;
      Api2()
        .get(
          "admins/managedacademy/" +
          this.$store.state.managedAcademy +
          "/member/" +
          this.memberId +
          "/activities"
        )
        .then((response) => {
          if (response) {
            if (!more)
              this.timelineDialog = true;
            this.loadingTimeline = false;
            this.meiScore = response.data.mei;
            for (const i of response.data.activities) {
              if (i.activity == 'purchase') {
                i.icon = 'mdi-cash-check';
                //i.color = this.themeColor("error");
              } else if (i.activity == 'class_checkin' || i.activity == 'social_checkin' || i.activity == 'checkin') {
                i.icon = 'mdi-map-marker-check-outline';
                i.color = this.themeColor("primary");
              } else if (i.activity == 'payment_method_update_member') {
                i.icon = 'mdi-credit-card-refresh-outline';
                i.color = this.themeColor("success");
              } else if (i.activity == 'completed_document') {
                i.icon = 'mdi-file-sign';
                i.color = this.themeColor("gray");
              } else if (i.activity == 'completed_syllabus_activity') {
                i.icon = 'mdi-check-circle-outlinen';
                i.color = this.themeColor("gold");
              } else if (i.activity == 'checkout') {
                i.icon = 'mdi-map-marker-right-outline';
                i.color = this.themeColor("primary");
              } else if (i.activity == 'react_post') {
                i.icon = 'oss';
              } else if (i.activity == 'view_post') {
                i.icon = 'mdi-eye-check-outline';
                i.color = "red";
              } else if (i.activity == 'view_video') {
                i.icon = 'mdi-video-check-outline';
                i.color = this.themeColor("purple");
              } else if (i.activity == 'event_checkin') {
                i.icon = 'mdi-calendar-check';
                i.color = this.themeColor("primary");
              } else if (i.activity == 'view_myacademy' || i.activity == 'view_academy') {
                i.icon = 'mdi-bank';
                i.color = this.themeColor("orange");
              } else if (i.activity == 'view_myacademy_calendar') {
                i.icon = 'mdi-calendar-search-outline';
                i.color = this.themeColor("orange");
              }
              i.title = this.$t('message.' + i.activity);
            }
            if (!more)
              this.activityTimeline = [];
            this.activityTimeline = this.activityTimeline.concat(response.data.activities);
          }
        });
    },
    updateMemberSalary() {
      Api()
        .patch("admins/managedacademy/" + this.$store.state.managedAcademy + "/member/" + this.memberId + '/salary',
          { pay: this.member.pay })
        .then(() => {
          this.showAlert("success", this.$t('message.updated'));
        })
        .catch(() => {
          this.showAlert("error", this.$t('message.error_generic'));
        });
    },
    completeCOFUpdate(id) {
      Api()
        .patch(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/payments/cc/update/complete/member/" +
          this.memberId +
          "/" +
          id
        )
        .then((response) => {
          if (response) {
            if (response.data.cardOnFile)
              this.cardOnFile = response.data.cardOnFile;
            this.showAlert("success", this.$t("message.updated"));
          }
        }).catch(() => {
          this.showAlert("error", this.$t("message.error_generic"));
        });
    },
    updateCOF() {
      if (this.isInfinicept) {
        this.navigateTo({
          name: "inifnicept-checkout",
          params: {
            transactionData: {
              memberId: this.memberId,
              action: 'update-card',
              memberName: this.member.displayName,
              routeFrom: 'viewmember'
            }
          }
        });
      } else {
        this.navigateTo({
          name: "updatecardmember",
          params: { memberId: this.memberId },
          query: { memberId: this.memberId, source: 'member' },
        });
      }
    },
    getUploads() {
      Api2()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/member/" +
          this.memberId + "/uploads"
        )
        .then((response) => {
          if (response.data && response.data.uploads && response.data.uploads.length) {
            this.uploads = response.data.uploads;
            this.member.memberData.uploads = this.uploads;
          }
        });
    },
    getUploadedFile(upload) {
      //Signed URL, go directly to bucket
      window.open(upload.url)
    },
    loadAttendance() {
      this.loadingAttendance = true;
      Api2()
        .get("admins/academy/" + this.$store.state.managedAcademy + "/member/" + this.memberId + '/attendance')
        .then(response => {
          if (response) {
            if (response.data && response.data.attendance.checkins) {
              const tmp = response.data.attendance.checkins;
              const totalCheckins = tmp.length;
              let lateCheckins = 0;
              for (let c of tmp) {
                c.isLate = this.isLateCheckin(c.date, c.start);
                if (c.isLate)
                  lateCheckins++;
              }
              if (tmp && tmp.length) {
                const onTimeCheckins = totalCheckins - lateCheckins;
                this.onTimeRate = (onTimeCheckins / totalCheckins) * 100;
              }
              this.attendance = tmp;
              const byWeek = response.data.attendance.weeks;
              const data = [];
              const categories = [];
              for (const d of byWeek) {
                const label = d.weeksAgo == 0 ? this.$t("message.this_week") : this.$t("message.weeks_ago", [d.weeksAgo]);
                categories.push(label);
                data.push(d.count);
              }
              const vm = this;
              this.attendanceByWeek.options = {
                theme: {
                  mode: this.isDarkMode() ? 'dark' : 'light',
                },
                chart: {
                  background: 'none',
                  height: 150,
                  type: 'bar',
                  toolbar: {
                    show: false
                  },
                },
                colors: [this.themeColor('primary')],
                plotOptions: {
                  bar: {
                    borderRadius: 10,
                    columnWidth: '30%',
                  }
                },
                dataLabels: {
                  enabled: true,
                  formatter: function (val) {
                    return val;
                  },
                  offsetY: -20,
                  style: {
                    fontSize: '12px',
                    colors: ["white"]
                  }
                },
                stroke: {
                  width: 2
                },
                grid: {
                  show: false,
                },
                yaxis: {
                  show: false
                },
                xaxis: {
                  labels: {
                    rotate: -45
                  },
                  categories: categories,
                  tickPlacement: 'on'
                },
                tooltip: {
                  y: {
                    formatter: function (value) {
                      return value + '';
                    }
                  },
                  x: {
                    formatter: function (value) {
                      const index = value - 1;
                      const weeksAgo = byWeek[index].weeksAgo;
                      const today = new Date();
                      today.setDate(today.getDate() - (7 * weeksAgo));
                      const day = today.getDay();
                      const diff = today.getDate() - day + (day == 0 ? -6 : 1);
                      today.setDate(diff);
                      return vm.$d(today, "month_day_year", vm.$i18n.locale);
                    }
                  }
                },
                fill: {
                  type: 'gradient',
                  gradient: {
                    shade: 'light',
                    type: "horizontal",
                    shadeIntensity: 0.25,
                    gradientToColors: undefined,
                    inverseColors: true,
                    opacityFrom: 0.85,
                    opacityTo: 0.85,
                    stops: [50, 0, 100]
                  },
                }
              };

              this.attendanceByWeek.data = [{
                name: this.$t("message.checkins"),
                data: data
              }];
            }
            /**
              dataLabels: {
                enabled: true,
                formatter: function (val) {
                  return val + "%";
                },
                offsetY: -20,
                style: {
                  fontSize: '12px',
                  colors: ["#304758"]
                }
              }, 
             */
            this.loadingAttendance = false;
          }
        })
        .catch((err) => {
          console.log('error: ', err)
          this.loadingAttendance = false;
        });
    },
    loadRecurrentPayments() {
      this.loadingRecurrentPayments = true;
      Api2()
        .get("admins/academy/" + this.$store.state.managedAcademy + "/member/" + this.memberId + '/recurrent')
        .then(response => {
          if (response) {
            if (response.data && response.data.recurrentPayments)
              this.recurrentPayments = response.data.recurrentPayments;
            this.loadingRecurrentPayments = false;
          }
        })
        .catch(() => {
          this.loadingRecurrentPayments = false;
        });
    },
    updateNotBjjUser() {
      const data = { attribute: 'notBjjUser', value: this.member.notBjjUser };
      Api()
        .patch("admins/academy/" + this.$store.state.managedAcademy + "/member/" + this.memberId + '/social', data)
        .then(response => {
          if (response) {
            this.showAlert("success", this.$t('message.updated'));
          }
        })
        .catch(() => {
          this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    updateNewMinorEmail() {
      if (this.newUser.isMinor) {
        this.newUser.email = this.member.email;
        this.newUser.password = this.generatePassword();
      } else {
        this.newUser.email = null;
        this.newUser.password = null;
      }
    },
    getFamilyMembers() {
      Api2()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/member/" +
          this.memberId +
          "/familymembers"
        )
        .then((response) => {
          if (response && response.data) {
            this.member.familyMembers = response.data.familyMembers;
            if (this.member.familyMembers.length > 0)
              this.hasFamilyMembers = true;
          }
        });
    },
    newUserReady() {
      if (this.newFamilyMember)
        return true;
      if (
        this.newUser.fName &&
        this.newUser.lName &&
        this.newUser.email &&
        (this.newUser.password || this.newUser.existing) &&
        this.newUser.nationality &&
        (this.newUser.notBjjUser || this.newUser.belt) &&
        (this.newUser.ageMin || this.newUser.isMinor)
      ) {
        return true;
      }
      return false;
    },
    showNewMemberDialog() {
      this.newUser = {
        familyMember: this.memberId,
        lName: this.member.lName,
        nationality: this.member.nationality
      };
      this.addNewMemberDialog = true;
    },
    removeFamilyMember(member) {
      Api()
        .patch(
          "admins/academy/" + this.$store.state.managedAcademy + "/remove/familymember",
          { familyUser: this.memberId, member: member }
        )
        .then(() => {
          this.getFamilyMembers();
        })
        .catch(() => {
          this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    addFamilyMember() {
      if (this.newFamilyMember) {
        Api()
          .patch(
            "admins/academy/" + this.$store.state.managedAcademy + "/add/familymember",
            { familyUser: this.memberId, member: this.newFamilyMember }
          )
          .then(() => {
            this.getFamilyMembers();
            this.addNewMemberDialog = false;
            this.$emit('refresh-search');
          })
          .catch(() => {
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
          });
        return;
      }
      try {
        if (!this.newUser.dob) {
          this.showAlert("error", this.$t("message.fill_all_params"));
          return;
        } else {
          let d = new Date(this.newUser.dob);
          d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0))
          this.newUser.dob = d;
        }
        this.registring = true;
        if (this.newUser.password) {
          let buff = new Buffer(this.newUser.password);
          let base64data = buff.toString("base64");
          this.newUser.password = base64data;
        }
        this.newUser.academy = this.$store.state.selectedAcademy;
        if (this.newUser.notBjjUser) this.newUser.belt = "white";
        this.newUser.existing = null;
        if (this.newUser.isMinor)
          this.newUser.guardianUser = this.memberId;
        else
          this.newUser.familyUser = this.memberId;
        Api()
          .post(
            "admins/academy/" + this.$store.state.managedAcademy + "/new_member",
            this.newUser
          )
          .then((response) => {
            try {
              if (response.data) {
                this.addNewMemberDialog = false;
                this.registring = false;
                //this.newUser = {};
                const newUser = response.data;
                //Load members again and approve this new member
                this.approveMember(newUser);
              }
            } catch (e) {
              console.log(e);
            }
          })
          .catch((e) => {
            this.registring = false;
            if (e.response.status == 409) {
              this.showAlert(
                "error",
                "Oops!",
                this.$t("message.already_a_user"),
                9000
              );
            } else {
              this.showAlert("error", "Oops!", "Error :(");
            }
          });
      } catch (err) {
        console.log(err)
      }
    },
    approveMember(member) {
      var data = { members: [member._id] };
      Api()
        .post(
          "admins/academy/" + this.$store.state.selectedAcademy + "/approve",
          data
        )
        .then((response) => {
          const data = response.data;
          if (data) {
            this.newUser = {};
            this.getFamilyMembers();
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    completeInstance() {
      Api()
        .patch(
          "syllabus/academy/" + this.$store.state.managedAcademy + "/instances/" +
          this.selectedInstance._id + "/complete"
        )
        .then((response) => {
          const data = response.data;
          if (data) {
            this.showAlert("success", this.$t("message.success"));
            this.getSyllabusInstances();
            this.selectedInstance = null;
            this.completeInstanceDialog = false;
          }
        })
        .catch(() => {
          this.showAlert("error", this.$t("message.error_generic"));
        });
    },
    updateNonBJJ() {
      Api()
        .patch(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/non-bjj/" +
          this.memberId,
          { value: this.member.notBjjUser }
        )
        .then((response) => {
          const data = response.data;
          if (data) {
            this.showAlert("success", this.$t("message.success"));
          }
        })
        .catch(() => {
          this.showAlert("error", this.$t("message.error_generic"));
        });
    },
    updateIsStaff() {
      Api()
        .patch(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/staff/" +
          this.memberId,
          { staff: this.member.staff }
        )
        .then((response) => {
          const data = response.data;
          if (data) {
            this.showAlert("success", this.$t("message.success"));
          }
        })
        .catch(() => {
          this.showAlert("error", this.$t("message.error_generic"));
        });
    },
    goToSellMembership() {
      this.navigateTo({
        name: "sellproduct",
        params: { productId: 'membership' },
        query: { userId: this.memberId },
      });
    },
    goToSellProduct() {
      this.navigateTo({ name: "bulksell", query: { userId: this.memberId } });
    },
    goToViewAttendance() {
      this.navigateTo({
        name: "viewattendancetabs",
        params: { tabId: '1' },
        query: { userId: this.memberId }
      });
    },
    usesGuardianEmail() {
      if (this.member && this.member.memberData &&
        (this.member.memberData.guardianEmail &&
          this.member.memberData.guardianEmail != this.member.email) ||
        (this.member.memberData.guardianUser))
        return true;
      return false;
    },
    removeGuardianUser() {
      Api()
        .patch(
          "admins/academy/" + this.$store.state.managedAcademy + "/remove/familymember",
          { member: this.member.memberData._id }
        )
        .then(() => {
          this.loadMemberProfile();
        })
        .catch(() => {
          this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    updateGuardianUser() {
      if (!this.member.guardianUser || (this.member.guardianUser && this.member.guardianUser._id != this.guardianUser)) {
        this.updateMemberData();
        this.member.guardianUser = this.guardianUser;
      }
    },
    updateFamilyUser() {
      if (!this.member.familyUser || (this.member.familyUser && this.member.familyUser._id != this.familyUser)) {
        this.updateMemberData();
        this.member.familyUser = this.familyUser;
      }
    },
    loadMemberProfile() {
      this.loading = true;
      this.purchases = [];
      this.payments = [];
      this.subscriptions = [];
      this.paymentMethod = null;
      this.guardianUser = null;
      this.familyUser = null;
      this.hasFamilyMembers = false;
      Api2()
        .get(
          "admins/academy/" +
          this.$store.state.selectedAcademy +
          "/member/" +
          this.memberId
        )
        .then((response) => {
          if (response.data.nonMember) {
            this.nonMember = response.data.user;
            this.visitorData = response.data.visitorData || null;
            const visitorId =
              (response.data.visitorData && response.data.visitorData._id) ||
              (response.data.memberData && response.data.memberData._id);
            if (visitorId) {
              this.goToVisitor(visitorId);
              return;
            }
            this.loading = false;
            return;
          }
          this.member = response.data;
          // Normalize phone to digits-only national number for display (prefix is shown separately)
          if (this.member.phone) {
            const country = this.member.academyCountry || null;
            const parsed = parsePhone(this.member.phone, country);
            if (parsed && parsed.nationalNumber) {
              this.member.phone = parsed.nationalNumber;
            } else {
              // Legacy format: strip non-digits
              this.member.phone = this.member.phone.replace(/\D/g, "");
              // If digits start with country calling code, strip it
              if (country) {
                const code = getCallingCode(country);
                if (code && this.member.phone.startsWith(code)) {
                  this.member.phone = this.member.phone.substring(code.length);
                }
              }
            }
          }
          this.member.whatsapp = this.getWhatsAppLink(this.member.phoneCode, this.member.phone);
          if (this.member && this.member.alternativeLevels)
            this.alternativeLevels = this.member.alternativeLevels;
          if (!this.member.pay) {
            this.member.pay = {
              ratePerClass: 0,
              salary: {
                amount: 0,
                interval: 'hour',
              },
            };
          } else if (!this.member.pay.salary) {
            this.member.pay.salary = {
              amount: 0,
              interval: 'hour',
            };
          }
          if (this.member.paymentsModule == 'infinicept')
            this.isInfinicept = true;
          if (this.member.guardianUser) {
            this.guardianUser = this.member.guardianUser._id;
          }
          this.previousData = { code: this.member.code };
          if (this.member.familyMembers && this.member.familyMembers.length > 0)
            this.hasFamilyMembers = true;
          if (this.member.familyUser)
            this.familyUser = this.member.familyUser._id;
          if (this.member.dob) {
            const daysUntilDob = this.daysUntilBirthDate(this.member.dob)
            if (daysUntilDob == 0)
              this.isBirthday = true;
          }
          //this.getMemberAlerts();
          this.isMember = true;
          if (this.member && !this.member.memberData) {
            Api2()
              .get(
                "admins/academy/" +
                this.$store.state.managedAcademy +
                "/member/" +
                this.memberId +
                "/data"
              )
              .then((response) => {
                if (response.data) {
                  this.member.memberData = response.data;
                }
              });
          }
          this.getMemberAlerts();
          Api2()
            .get(
              "payments/academy/" +
              this.$store.state.managedAcademy +
              "/customer/" +
              this.memberId
            )
            .then((response) => {
              if (response.data && response.data.paymentMethod) {
                this.paymentMethod = response.data.paymentMethod;
                if (this.paymentMethod.expYea) {
                  let expDate = new Date();
                  expDate.setFullYear(this.paymentMethod.expYear);
                  expDate.setMonth(this.paymentMethod.expMonth - 1);
                  this.paymentMethod.expDate = expDate;
                  this.paymentMethod.expired = this.isExpired(expDate);
                }
              }
            });
          this.loading = false;
          if (this.member && this.member.transactions) {
            let expiredManuals = [];
            this.subscriptions = [];

            for (const t of this.member.transactions) {
              const isMembershipCategory = t.category === 'membership' || t.subscription || t.manualRecurrence;
              const isValidTransaction = !t.cancelled && t.product && !t.parentTransaction;

              if (isValidTransaction && isMembershipCategory) {
                const isExpired = t.expired || (t.subscriptionEndDate && new Date(t.subscriptionEndDate) < new Date());
                if (!isExpired) {
                  this.subscriptions.push(t);
                } else if (t.manualRecurrence) {
                  expiredManuals.push(t);
                }
              }
              this.purchases.push(t);
            }

            if (expiredManuals.length > 0) {
              expiredManuals.sort((a, b) => {
                const dateA = a.subscriptionEndDate ? new Date(a.subscriptionEndDate) : 0;
                const dateB = b.subscriptionEndDate ? new Date(b.subscriptionEndDate) : 0;
                return dateB - dateA;
              });

              const latestExpired = expiredManuals[0];
              const hasActiveReplacement = this.subscriptions.some(s => s.product === latestExpired.product);

              if (!hasActiveReplacement) {
                this.subscriptions.push(latestExpired);
              }
            }
          }
          if (this.member && this.member.expenses) {
            this.expenses = this.member.expenses;
          }
        })
        .catch((e) => {
          this.loading = false;
          console.log(e)
          this.memberError = true;
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
      const postData = { user: this.memberId };
      Api()
        .post(
          "documents/academy/" + this.$store.state.managedAcademy + "/completed",
          postData
        )
        .then((response) => {
          if (response.data && response.data.length > 0)
            this.documents = response.data;
        });
      this.getSyllabusInstances();
      this.getSyllabusTemplates();
      this.getReferralCampains();
    },
    rejectMember() {
      //Add confirmation modal here...
      Api()
        .post(
          "admins/academy/" + this.$store.state.selectedAcademy + "/reject",
          { members: [this.memberId], reason: this.cancellationReason }
        )
        .then((response) => {
          const data = response.data;
          if (data) {
            this.navigateTo({ name: 'members' })
          }
        })
        .catch((e) => {
          if (e) {
            if (e.response.data.message_translation)
              this.showAlert(
                "error",
                this.$t("message." + e.response.data.message_translation),
                null,
                8000
              );
            else
              this.showAlert(
                "error",
                "Oops!",
                this.$t("message.error_generic")
              );
          }
        });
    },
    getExpirationString(s) {
      let text = '';
      if (s.subscriptionEndDate || s.subscriptionCheckins) {
        text = this.$t("message.expires") + ' ';
        if (s.subscriptionEndDate)
          text += this.$t("message.on") + ' ' + this.$d(new Date(s.subscriptionEndDate), "month_day_year", this.$i18n.locale);
        if (s.subscriptionEndDate && s.subscriptionCheckins)
          text += ' ' + this.$t("message.or").toLowerCase() + ' ';
        if (s.subscriptionCheckins)
          text += this.$t("message.in") + ' ' + (s.subscriptionCheckins - s.checkins) + ' ' + this.$t("message.checkins");
      }
      return text;
    },
    closeSendNotiDialog() {
      this.sendNotiDialog = false;
      this.subject = "";
      this.notificationContents = null;
    },
    sendNotificationToMember() {
      var recipients = [this.memberId];
      var postData = {};
      if (
        recipients.length > 0 &&
        this.notificationContents &&
        this.notificationContents != "" &&
        this.subject &&
        this.subject != ""
      ) {
        postData.recipients = recipients;
        postData.subject = this.subject;
        postData.contents = this.notificationContents;
        Api()
          .post(
            "admins/academy/" +
            this.$store.state.selectedAcademy +
            "/send/notifications",
            postData
          )
          .then((response) => {
            const data = response.data;
            if (data) {
              this.showAlert("success", "Oss!", ":)");
              this.closeSendNotiDialog();
            }
          })
          .catch((e) => {
            if (e)
              this.showAlert(
                "error",
                "Oops!",
                this.$t("message.error_generic")
              );
          });
      } else {
        this.showAlert("info", this.$t("message.fill_all_params"), ":(");
      }
    },
    closeSendEmailDialog() {
      this.sendEmailDialog = false;
      this.emailSubject = "";
      this.emailContents = "";
      this.customEmails = [];
      this.emailErrors = [];
    },
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    validateEmails() {
      this.emailErrors = [];
      const invalidEmails = this.customEmails.filter(email => !this.isValidEmail(email));
      if (invalidEmails.length > 0) {
        this.emailErrors = [`Invalid email(s): ${invalidEmails.join(', ')}`];
      }
    },
    removeEmail(email) {
      const index = this.customEmails.indexOf(email);
      if (index >= 0) {
        this.customEmails.splice(index, 1);
      }
      this.validateEmails();
    },
    sendEmailToMember() {
      this.sendingEmail = true;
      this.validateEmails();

      const recipients = [this.memberId];
      const validCustomEmails = this.customEmails.filter(email => this.isValidEmail(email));
      const hasRecipients = recipients.length > 0 || validCustomEmails.length > 0;

      if (hasRecipients && this.emailContents && this.emailSubject && this.emailErrors.length === 0) {
        const postData = {
          recipients: recipients,
          subject: this.emailSubject,
          contents: this.emailContents,
          bcc: validCustomEmails,
          sendCopy: false
        };

        Api()
          .post(
            "admins/v2/academy/" + this.$store.state.managedAcademy + "/send/emails",
            postData
          )
          .then((response) => {
            if (response.data) {
              this.showAlert("success", "Oss!", ":)");
              this.closeSendEmailDialog();
            }
            this.sendingEmail = false;
          })
          .catch((e) => {
            this.sendingEmail = false;
            if (e) this.showAlert("error", "Oops!", this.$t("message.error_generic"));
          });
      } else {
        this.sendingEmail = false;
        this.showAlert("info", this.$t("message.fill_all_params"), ":(");
      }
    },
    submitUpdatePicture(data) {
      const newImage = data.location;
      const smallerFile = data.smallImageLocation;
      Api()
        .patch("admins/academy/" + this.$store.state.managedAcademy + "/member/" + this.memberId + '/image',
          {
            userImage: newImage,
            userImageSmall: smallerFile
          })
        .then(response => {
          if (response) {
            this.member.userImage = data.original;
          }
        })
        .catch(e => {
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    getMemberBeltHistory() {
      Api2()
        .get("admins/academy/" + this.$store.state.managedAcademy + "/member/" + this.memberId + "/history/belt")
        .then(response => {
          if (response && response.data.history && response.data.history.length > 0) {
            this.beltHistory = response.data.history;
          }
        });
    },
    showUpdateSocialProfileDialog(attribute) {
      this.editSocialProfileDialog = true;
      this.socialProfileUpdateData = {
        attribute: attribute,
        value: null
      };
      if (attribute == 'fName') {
        this.socialProfileUpdateData.title = this.$t("message.update_first_name");
        this.socialProfileUpdateData.value = this.member.fName;
      } else if (attribute == 'dob') {
        this.socialProfileUpdateData.title = this.$t("message.dob");
        if (this.member.dob)
          this.socialProfileUpdateData.date = this.dateFromStringInTZ(this.member.dob);
      } else if (attribute == 'lName') {
        this.socialProfileUpdateData.title = this.$t("message.update_last_name");
        this.socialProfileUpdateData.value = this.member.lName;
      } else if (attribute == 'email') {
        this.socialProfileUpdateData.title = this.$t("message.update_email");
        this.socialProfileUpdateData.value = this.member.email;
      } else if (attribute == 'password') {
        this.socialProfileUpdateData.title = this.$t("message.reset_password");
      } else if (attribute == 'isMinor') {
        this.socialProfileUpdateData.title = this.$t("message.is_minor");
        this.socialProfileUpdateData.value = this.member.isMinor;
      } else if (attribute == 'belt') {
        this.socialProfileUpdateData.title = this.$t("message.update_belt");
        this.socialProfileUpdateData.value = this.member.belt;
      } else if (attribute == 'nationality') {
        this.socialProfileUpdateData.title = this.$t("message.update_nationality");
        this.socialProfileUpdateData.value = this.member.nationality;
      } else if (attribute == 'gender') {
        this.socialProfileUpdateData.title = this.$t("message.update_gender");
        this.socialProfileUpdateData.value = this.member.gender;
      }
    },
    updateSocialProfile() {
      this.updatingSocialProfile = true;
      if (this.socialProfileUpdateData.date) {
        let d = new Date(this.socialProfileUpdateData.date);
        d.setHours(1);
        d.setMinutes(0);
        this.socialProfileUpdateData.date = d;
        if (this.socialProfileUpdateData.attribute == 'dob') {
          this.socialProfileUpdateData.value = this.forceDateToUTC(d);
          this.socialProfileUpdateData.date = this.forceDateToUTC(d);
        }
      }
      Api()
        .patch("admins/academy/" + this.$store.state.managedAcademy + "/member/" + this.memberId + '/social', this.socialProfileUpdateData)
        .then(response => {
          if (response) {
            this.showAlert("success", this.$t('message.success'));
            //Update user
            if (this.socialProfileUpdateData.attribute == 'belt') {
              Api2()
                .get(
                  "admins/academy/" +
                  this.$store.state.selectedAcademy +
                  "/member/" +
                  this.memberId
                )
                .then((response2) => {
                  this.member = response2.data;
                });
              this.getMemberBeltHistory();
              this.loadMemberProfile();
            } else {
              this.loadMemberProfile();
            }
            this.editSocialProfileDialog = false;
            this.socialProfileUpdateData.date = null;
            this.socialProfileUpdateData.value = null;
            this.updatingSocialProfile = false;
          }
        })
        .catch(e => {
          this.updatingSocialProfile = false;
          if (e.response.data.message_translation)
            this.showAlert("error", "Oops!", this.$t("message." + e.response.data.message_translation));
          else
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    deleteInstance() {
      Api()
        .delete("syllabus/academy/" + this.$store.state.managedAcademy + "/instances/" + this.selectedInstance._id)
        .then(response => {
          if (response) {
            this.showAlert("success", this.$t('message.success'));
            this.getSyllabusInstances();
            this.selectedInstance = null;
            this.deleteInstanceDialog = false;
          }
        })
        .catch(e => {
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    showDeleteSyllabusLevelDialog(d) {
      this.syllabusLevelToDelete = d;
      this.deleteSyllabusLevelDialog = true;
    },
    deleteSyllabusLevel() {
      if (!this.syllabusLevelToDelete || !this.selectedInstance) return;
      this.deletingSyllabusLevel = true;
      const escapedLevel = this.syllabusLevelToDelete.level.replace(/\//g, "%2F");
      const instance = this.selectedInstance;
      Api()
        .delete("syllabus/academy/" + this.$store.state.managedAcademy + "/instances/" + instance._id + "/level/" + escapedLevel)
        .then(response => {
          if (response) {
            this.showAlert("success", this.$t('message.success'));
            this.deleteSyllabusLevelDialog = false;
            this.syllabusLevelToDelete = null;
            this.getSyllabusInstance(instance);
            this.getSyllabusInstances();
          }
        })
        .catch(e => {
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        })
        .finally(() => {
          this.deletingSyllabusLevel = false;
        });
    },
    isCheckinsRule(ruleType) {
      if (ruleType && ruleType.indexOf('checkins') >= 0)
        return true;
      return false;
    },
    goToTransactionId(t) {
      this.navigateTo({ name: 'viewtransaction', params: { sessionId: t } });
    },
    goToTransaction(t) {
      if (t.product) {
        this.navigateTo({ name: 'viewtransaction', params: { sessionId: t._id } });
      } else {
        this.navigateTo({ name: 'viewitemstransaction', params: { transactionId: t._id } })
      }
    },
    updateInstance(i) {
      Api()
        .patch("syllabus/academy/" + this.$store.state.managedAcademy + "/instances/" + i._id + "/display", { displayOnProfile: i.displayOnProfile })
        .then(response => {
          if (response.data) {
            if (response.data.alreadyHadOne) {
              this.showAlert("success", this.$t('message.display_on_profile_off'), null, 8000);
              for (let instance of this.syllabusInstances) {
                if (instance._id == response.data.alreadyHadOne) {
                  instance.displayOnProfile = false;
                }
              }
            }
          }
        })
        .catch(e => {
          console.log(e)
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    toggleInstanceShowDetails(i) {
      Api()
        .patch("syllabus/academy/" + this.$store.state.managedAcademy + "/instances/" + i._id + "/display/details", { displayDetails: i.displayDetails })
        .then(response => {
          if (response.data) {
            this.showAlert("success", this.$t("message.success"));
          }
        })
        .catch(e => {
          console.log(e)
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    updateInstanceDataRules(event, dataId, ruleId) {
      const instanceLevels = this.selectedInstance.data;
      let currentLevel = null;
      let updatedRule = null;
      if (instanceLevels && instanceLevels.length > 0) {
        let updated = false;
        for (let instanceLevel of instanceLevels) {
          if (updated)
            break;
          if (instanceLevel._id == dataId) {
            currentLevel = instanceLevel;
            if (instanceLevel.instanceRules) {
              for (let r of instanceLevel.instanceRules) {
                if (r.ruleId == ruleId) {
                  updated = true;
                  updatedRule = {
                    _id: r._id,
                    ruleId: r.ruleId,
                    numberValue: r.numberValue != null ? event : null,
                    booleanValue: r.booleanValue != null ? event : null,
                  };
                  break;
                }
              }
            }
          }
        }
      }
      if (updatedRule) {
        Api()
          .patch("syllabus/academy/" + this.$store.state.managedAcademy + "/instances/data/" + dataId + "/rules/", updatedRule)
          .then(response => {
            if (response.data) {
              currentLevel.overallPercent = response.data.progress;
              if (currentLevel.overallPercent == 100)
                this.canLevelUp = true;
              else
                this.canLevelUp = false;
            }
          })
          .catch(e => {
            if (e)
              this.showAlert("error", "Oops!", this.$t('message.error_generic'));
          });
      }
    },
    assignLevel() {
      const escapedLevelToAssign = this.levelToAssign.replace(/\//g, "%2F");
      Api()
        .post("syllabus/academy/" + this.$store.state.managedAcademy + "/instances/" + this.selectedInstance._id + "/level/" + escapedLevelToAssign)
        .then(response => {
          if (response) {
            this.getSyllabusInstances();
            this.canLevelUp = false;
            this.assignLevelDialog = false;
            this.levelToAssign = null;
            this.selectedInstance = null;
            this.syllabusInstancesPanel = null;
          }
        })
        .catch(e => {
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    getSyllabusTemplate(instance) {
      Api2()
        .get("syllabus/academy/" + this.$store.state.managedAcademy + "/templates/" + instance.syllabusTemplate._id)
        .then(response => {
          if (response) {
            this.selectedTemplate = response.data.template;
            if (this.selectedTemplate && this.selectedTemplate.levels) {
              let levelsPicker = [];
              let useMonthlyBelts = false;
              let position = !instance.currentLevel ? 0 : null;
              for (const l of this.selectedTemplate.levels) {
                if (!useMonthlyBelts && l.level.indexOf('_m_') > 0)
                  useMonthlyBelts = true;
                if (position >= 0 && l.level != instance.currentLevel) {
                  levelsPicker.push({ text: l.level, value: l.level });
                }
                if (instance.currentLevel && instance.currentLevel == l.level)
                  position = l.position;
              }
              this.selectedTemplate.levelsPicker = levelsPicker;
              this.selectedTemplate.useMonthlyBelts = useMonthlyBelts;
            }
          }
        })
        .catch(e => {
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    getSyllabusInstances() {
      Api2()
        .get(
          "syllabus/academy/" + this.$store.state.managedAcademy + "/instances/member/" +
          this.memberId)
        .then((response) => {
          if (response.data && response.data.instances) {
            if (response.data.instances && response.data.instances.length > 0)
              this.syllabusInstances = response.data.instances;
            else
              this.syllabusInstances = null;
            if (this.syllabusInstanceId && this.syllabusInstances && this.syllabusInstances.length > 0) {
              let index = 0;
              for (const i of this.syllabusInstances) {
                if (i._id == this.syllabusInstanceId) {
                  this.getSyllabusInstance(i);
                  this.syllabusInstancesPanel = index;
                  break;
                }
                index++;
              }
            }
          }
        });
    },
    assignSyllabusToMember() {
      var recipients = [this.memberId];
      Api()
        .post(
          "syllabus/academy/" +
          this.$store.state.managedAcademy +
          "/templates/" +
          this.selectedSyllabus + "/assign",
          { users: recipients }
        )
        .then((response) => {
          if (response) {
            this.showAlert(
              "success",
              this.$t("message.assigned_to_members", [response.data.total])
            );
            this.assignSyllabusDialog = false;
            this.getSyllabusInstances();
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert(
              "error",
              "Oops!",
              this.$t("message.error_generic")
            );
        });
    },
    getSyllabusTemplates() {
      Api2()
        .get("syllabus/academy/" + this.$store.state.managedAcademy + "/templates")
        .then(response => {
          if (response) {
            if (response.data.templates && response.data.templates.length) {
              this.syllabusTemplates = [];
              for (const t of response.data.templates)
                this.syllabusTemplates.push({ text: t.name, value: t._id });
            }
          }
        });
    },
    getSyllabusInstance(instance) {
      this.selectedInstance = instance;
      this.canLevelUp = false;
      Api2()
        .get("syllabus/academy/" + this.$store.state.managedAcademy + "/instances/" + instance._id)
        .then(response => {
          if (response.data) {
            if (response.data.instance.data)
              this.selectedInstance.data = response.data.instance.data.reverse();
            this.selectedInstance.colors = response.data.colors;
            const templateRulesDefinitions = response.data.templateLevelRules;
            for (const levelData of this.selectedInstance.data) {
              if (this.selectedInstance.currentLevel == levelData.level && levelData.overallPercent == 100)
                this.canLevelUp = true
              //Add rule type for each level rule
              if (templateRulesDefinitions && templateRulesDefinitions[levelData.level]) {
                for (let instanceRule of levelData.instanceRules) {
                  if (templateRulesDefinitions[levelData.level][instanceRule.ruleId]) {
                    instanceRule.ruleType = templateRulesDefinitions[levelData.level][instanceRule.ruleId].ruleType;
                    instanceRule.category = templateRulesDefinitions[levelData.level][instanceRule.ruleId].category;
                    instanceRule.details = templateRulesDefinitions[levelData.level][instanceRule.ruleId].details;
                    instanceRule.text = templateRulesDefinitions[levelData.level][instanceRule.ruleId].text;
                    instanceRule.longText = templateRulesDefinitions[levelData.level][instanceRule.ruleId].longText;
                  }
                }
                //Sort the rules by category
                levelData.instanceRules = this.sortInstanceLevelRules(levelData);
              }
            }
          }
        });
      this.getSyllabusTemplate(instance);
    },
    sortInstanceLevelRules(levelData) {
      let arr = levelData.instanceRules;
      const withCategory = [];
      const withoutCategory = [];

      arr.forEach(item => {
        if (Object.prototype.hasOwnProperty.call(item, 'category')) {
          withCategory.push(item);
        } else {
          withoutCategory.push(item);
        }
      });

      // Sort items with 'category' alphabetically by 'category'
      withCategory.sort((a, b) => {
        const catA = a.category || '';
        const catB = b.category || '';
        return catA.localeCompare(catB);
      });

      // Concatenate sorted withCategory + original-order withoutCategory
      return [...withCategory, ...withoutCategory];
    },
    deleteMemberBeltHistory(id) {
      Api()
        .delete(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/member/" +
          this.memberId +
          "/history/" + id
        )
        .then((response) => {
          if (response.data) {
            Api2()
              .get(
                "admins/academy/" +
                this.$store.state.selectedAcademy +
                "/member/" +
                this.memberId
              )
              .then((response2) => {
                this.member = response2.data;
              });
            this.getMemberBeltHistory();
            this.loadMemberProfile();
            this.showAlert("success", this.$t("message.removed"));
          }
        });
    },
    deletePaymentMethod() {
      Api()
        .delete(
          "payments/academy/" +
          this.$store.state.managedAcademy +
          "/customer/" +
          this.memberId +
          "/paymentmethod"
        )
        .then((response) => {
          if (response.data) {
            this.paymentMethod = null;
            this.deletePaymentMethodDialog = false;
            this.showAlert("success", this.$t("message.removed"));
          }
        });
    },
    getFileIcon(type) {
      if (type == "pdf") return "picture_as_pdf";
      else if (
        type == "csv" ||
        type == "xls" ||
        type == "xlsx" ||
        type == "xls"
      )
        return "table_view";
      else if (
        type == "txt" ||
        type == "rtf" ||
        type == "doc" ||
        type == "docx"
      )
        return "article";
      else if (type == "png" || type == "jpg" || type == "jpeg") return "photo";
      else return "file_copy";
    },
    onFileSelect(event) {
      if (event.target.files[0]) {
        const size = event.target.files[0].size;
        const sizeMb = (size / 1000000).toFixed(1);
        if (sizeMb > 100.0) {
          this.showAlert(
            "error",
            this.$t("message.file_too_big") + " (< 100 MB)"
          );
          return;
        } else {
          this.uploadingFile = true;
          this.selectedFile = event.target.files[0];
          this.uploadFile();
        }
      } else {
        this.uploading = false;
      }
    },
    removeUploadedFile() {
      if (!this.selectedUploadId) return;
      const postData = {
        _id: this.selectedUploadId,
      };
      //post
      Api()
        .patch(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/member/" +
          this.memberId +
          "/uploads/" +
          this.member.memberData._id,
          postData
        )
        .then(() => {
          this.getUploads();
          this.deleteUploadDialog = false;
          this.selectedUploadId = null;
        });
    },
    uploadFile() {
      const formData = new FormData();
      const d = new Date();
      const millis = d.getTime();
      const imgExtension = this.selectedFile.type.toLowerCase().split('/')[1];
      const blob = new Blob([this.selectedFile], { type: this.selectedFile.type });
      const fileName = this.selectedFile.name + '-' + millis + '.' + imgExtension
      formData.append("file", blob, fileName);

      Api2().post("content/file/admin", formData)
        .then(res => {
          if (res) {
            //Now push the file to backend
            const url = res.data.location;
            const type = res.data.type;
            const postData = {
              url: url,
              fileName: fileName,
              type: type,
            };
            //post
            Api()
              .patch(
                "admins/academy/" +
                this.$store.state.managedAcademy +
                "/member/" +
                this.memberId +
                "/uploads/" +
                this.member.memberData._id,
                postData
              )
              .then(() => {
                this.getUploads();
                this.uploadingFile = false;
              });
          }
        })
        .catch(err => {
          console.log(err);
          this.uploadingFile = false;
          const errorMessage =
            err.response && err.response.data.message
              ? this.$t("message." + err.response.data.message)
              : this.$t("message.oops_not_working");
          this.showAlert("error", errorMessage);
        });
    },
    updateTags() {
      Api()
        .patch(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/member/" +
          this.memberId +
          "/tags",
          { tags: this.member.tags }
        )
        .then((response) => {
          if (response.data) {
            this.member.tags = response.data;
            this.showAlert("success", this.$t("message.success"));
          }
        });
    },
    normalizeAndSaveAltEmails() {
      this.member.memberData.altEmails = (this.member.memberData.altEmails || [])
        .map(e => e.trim().toLowerCase())
        .filter(e => e.length > 0);
      this.updateMemberData();
    },
    updateMemberData() {
      if (this.loading)
        return;
      if (
        this.member.memberData.guardianEmail &&
        this.member.memberData.guardianEmail == ""
      )
        this.member.memberData.guardianEmail = null;
      if (this.guardianUser) {
        this.member.memberData.guardianEmail = null;
        this.member.memberData.guardian = null;
      }
      const memberData = {
        address: this.member.memberData.address,
        emergencyContact: this.member.memberData.emergencyContact,
        guardian: this.member.memberData.guardian,
        guardianEmail: this.member.memberData.guardianEmail,
        altEmails: this.member.memberData.altEmails || [],
        guardianUser: this.guardianUser,
        familyUser: this.familyUser,
        notes: this.member.memberData.notes,
      };
      Api()
        .patch(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/member/" +
          this.memberId +
          "/data/" +
          this.member.memberData._id,
          memberData
        ).then((response) => {
          const data = response.data;
          if (data) {
            this.showAlert("success", this.$t("message.success"));
            //this.updateMemberData();
          }
        })
        .catch(() => {
          this.loading = false;
          this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    updateMemberAddress() {
      if (this.selectedLocation) {
        const memberId = this.memberId;
        Api()
          .patch(
            "admins/academy/" +
            this.$store.state.managedAcademy +
            "/member/" +
            memberId + "/address",
            { location: this.selectedLocation }
          )
          .then((response) => {
            const data = response.data;
            if (data) {
              this.showAlert("success", this.$t("message.success"));
            }
          })
          .catch((e) => {
            if (e)
              this.showAlert("error", "Ops!", this.$t("message.error_generic"));
          });
      }
    },
    digitsOnly(e) {
      const char = String.fromCharCode(e.keyCode || e.which);
      if (!/\d/.test(char)) {
        e.preventDefault();
      }
    },
    onPhoneInput(value) {
      if (!this.member) return;
      const digits = (value || "").replace(/\D/g, "");
      this.member.phone = digits;
      this.phoneError = "";
      this.formattedPhone = "";
    },
    updatePhone() {
      this.phoneError = "";
      this.formattedPhone = "";
      const phone = this.member.phone;
      if (!phone || !phone.trim()) return;

      const country = this.member.academyCountry || null;
      const callingCode = country ? getCallingCode(country) : this.member.phoneCode;
      const formatted = formatPhoneInternational(phone, country);
      if (formatted) {
        this.formattedPhone = formatted;
      }

      if (!isValidPhone(phone, country) && !(callingCode && isValidPhone("+" + callingCode + phone, null))) {
        this.phoneError = this.$t("message.invalid_phone_number") || "Invalid phone number";
        return;
      }

      // Normalize: prepend country code for digits-only input
      let phoneToSend = phone;
      if (callingCode && !phone.startsWith("+")) {
        const withPrefix = "+" + callingCode + phone;
        const norm = normalizePhone(withPrefix);
        if (norm.isValidated) {
          phoneToSend = norm.phone;
          this.formattedPhone = formatPhoneInternational(phoneToSend) || "";
        }
      }

      const memberId = this.memberId;
      Api()
        .post(
          "admins/academy/" +
          this.$store.state.selectedAcademy +
          "/phone/" +
          memberId,
          { phone: phoneToSend }
        )
        .then((response) => {
          const data = response.data;
          if (data) {
            // Keep national number in the field (prefix is shown separately)
            const country = this.member.academyCountry || null;
            const parsed = parsePhone(phoneToSend, country);
            this.member.phone = parsed ? parsed.nationalNumber : phone;
            this.showAlert("success", this.$t("message.success"));
          }
        })
        .catch((e) => {
          if (e && e.response && e.response.status === 400) {
            this.phoneError = e.response.data.error || "Invalid phone number";
          } else {
            this.showAlert("error", "Ops!", this.$t("message.error_generic"));
          }
        });
    },
    updateCode() {
      if (this.previousData.code != this.member.code) {
        let memberId = this.memberId;
        if (this.member.code && this.member.code.length > 6) {
          this.showAlert("warning", this.$t("message.invalid_code"));
          return;
        }
        if (this.member.code && this.member.code.length < 6) {
          this.showAlert("warning", this.$t("message.invalid_code"));
          return;
        }
        Api()
          .post(
            "admins/academy/" +
            this.$store.state.selectedAcademy +
            "/code/" +
            memberId,
            { code: this.member.code }
          )
          .then((response) => {
            const data = response.data;
            if (data) {
              this.showAlert("success", this.$t("message.success"));
            }
          })
          .catch((e) => {
            if (e.response.status === 409) {
              const member = e.response.data.member;
              this.showAlert("error", this.$t("message.duplicate_code") + ": " + member);
            } else {
              this.showAlert("error", "Oops!", ":(");
            }
          });
      }
    },
    getMemberAcademyActivity() {
      Api2()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/activity/" +
          this.memberId
        )
        .then((response) => {
          this.activity = response.data;
        });
    },
    getMemberAlerts() {
      Api2()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/member/" +
          this.memberId +
          "/alerts"
        )
        .then((response) => {
          if (response && response.data) {
            this.alerts = response.data.alerts;
            this.alertsCount = response.data.alerts.length;
          }
        });
    },
    viewDocument(item) {
      this.navigateTo({ name: 'viewcompleteddocument', params: { documentId: item._id }, })
    },
    getTotal(t) {
      if (t.coupon && (t.coupon.discountAmount > 0 || t.coupon.discountPercent > 0))
        return t.coupon.discountedTotal;
      const q = t.quantity;
      const a = t.amount != null ? t.amount : (t.product ? t.product.amountDecimal : 0);
      return (q * a).toFixed(2);
    },
    getEmails() {
      this.loadingEmails = true;
      let options = { email: this.member.email, source: 'all' };

      Api()
        .post("admins/academy/" + this.$store.state.managedAcademy + "/emails", options)
        .then((response) => {
          this.emails = response.data.emails;
          this.loadingEmails = false;
        });
    },
    getEmail(email) {
      email.opening = true;
      const id = email._id ? email._id : 'grouped';
      Api2()
        .get(
          "admins/academy/" + this.$store.state.managedAcademy + "/emails/" + id + '?' +
          (email.group ? 'group=' + email.group : '')
        )
        .then((response) => {
          this.email = response.data.email;
          this.emailDialog = true;
          email.opening = false;
        });
    },
  },
};
</script>

<style scoped>
.data-panel {
  overflow: auto;
  max-height: 500px;
}

.bday-floater {
  left: 1%;
  position: absolute;
}

.syllabus-text-input {
  max-width: 40px
}
</style>
